
// Manually extracted from both offshore and onshore:
//     https://github.com/TheWorldSim/world-sim-data/blob/ed6d3ae/data/power_plants/uk/data/solar_processed_REPD_publication_Q1_2026.csv
// using Rainbow CSV with a RBQL query of:
// SELECT a1, a3, a4.slice(0,4), a5, a6, a7, (a2 == "Operational" ? '"o"' : '"uc"') WHERE ["Operational", "Under Construction"].includes(a2) && a3 !== "" && a5 !== "inf" && a6 !== "inf"

import { RawSolarFarmData } from "./interface"

// Ref ID,Installed Capacity (MWelec),Operational,lon,lat,area (sqm),operational or under construction
export const solar_farms: RawSolarFarmData[] = [
[1018,1.0,2011,0.069,53.423,18456,"o"],
[1019,4.7,2011,-4.836,50.337,81900,"o"],
[1020,4.7,2011,-5.368,50.218,106000,"o"],
[1021,4.4,2011,-4.282,50.442,114000,"o"],
[1022,5.0,2011,-4.427,50.87,98500,"o"],
[1023,1.7,2011,-5.069,50.395,31573,"o"],
[1024,5.0,2012,-4.486,50.924,93411,"o"],
[1028,2.9,2011,-5.082,50.304,54060,"o"],
[1029,5.0,2011,1.399,52.805,120000,"o"],
[1032,1.4,2011,-5.123,50.238,25952,"o"],
[1034,5.0,2013,0.067,52.172,170000,"o"],
[1035,2.0,2011,-4.783,50.54,60000,"o"],
[1039,5.0,2011,-4.009,50.389,93411,"o"],
[1040,4.6,2011,-0.815,53.028,146000,"o"],
[1041,4.9,2011,1.346,51.316,119700,"o"],
[1042,1.3,2012,-0.956,51.845,31600,"o"],
[1046,2.0,2011,-2.966,51.123,37195,"o"],
[1047,4.6,2011,-2.968,51.176,129700,"o"],
[1048,4.6,2011,-1.575,52.877,85915,"o"],
[1049,1.7,2011,0.135,52.79,31573,"o"],
[1050,1.0,2011,0.136,52.79,26000,"o"],
[1053,5.0,2013,-1.802,52.019,93411,"o"],
[1054,5.0,2011,-1.644,51.619,93411,"o"],
[1055,1.0,2011,-4.621,52.035,18456,"o"],
[1056,3.9,2011,-2.916,51.723,130500,"o"],
[1058,5.0,2013,-1.005,52.102,141000,"o"],
[1059,1.0,2013,-5.111,50.383,18456,"o"],
[1060,7.0,2013,-2.174,50.711,181000,"o"],
[1062,6.3,2013,0.218,52.315,164000,"o"],
[1064,5.8,2013,-4.758,50.407,108402,"o"],
[1065,1.1,2013,-4.958,50.373,20330,"o"],
[1067,3.0,2013,-4.428,50.452,55934,"o"],
[1070,4.0,2011,-2.923,50.79,126000,"o"],
[1076,5.0,2011,-2.673,51.105,128000,"o"],
[1078,1.7,2011,1.596,52.438,31573,"o"],
[1079,5.0,2011,-2.109,51.624,141600,"o"],
[1080,5.0,2011,-4.956,50.367,146000,"o"],
[1081,1.0,2011,-2.831,50.885,18456,"o"],
[1082,4.5,2011,-1.366,50.71,84042,"o"],
[1084,2.0,2011,-0.545,51.119,37195,"o"],
[1085,1.2,2013,0.038,52.451,22204,"o"],
[1086,5.3,2013,-1.458,50.894,99033,"o"],
[1088,5.3,2013,-5.194,50.142,130000,"o"],
[1089,5.0,2013,-3.037,51.112,156000,"o"],
[1090,5.0,2013,-2.506,50.643,93411,"o"],
[1091,7.0,2013,-1.607,51.42,189000,"o"],
[1094,6.7,2013,-4.401,50.79,125267,"o"],
[1095,3.2,2013,-1.302,50.735,83000,"o"],
[1096,4.8,2013,-1.204,50.642,152000,"o"],
[1097,5.3,2013,-0.383,52.318,166000,"o"],
[1098,1.3,2013,-5.225,50.171,24078,"o"],
[1103,5.0,2013,-2.971,51.12,93411,"o"],
[1108,15.0,2016,1.309,52.498,280797,"o"],
[1128,5.0,2016,1.184,52.797,93411,"o"],
[1157,6.3,2013,-1.308,50.949,160000,"o"],
[1158,5.3,2013,-4.442,50.781,99033,"o"],
[1160,1.0,2012,-2.838,50.883,18456,"o"],
[1161,5.5,2012,-4.239,51.725,102780,"o"],
[1163,9.0,2013,1.09,52.698,168366,"o"],
[1165,5.0,2011,-2.244,51.347,93411,"o"],
[1166,12.0,2013,0.369,51.967,299600,"o"],
[1169,5.0,2015,-2.047,52.152,93411,"o"],
[1171,5.0,2013,-0.026,52.53,93411,"o"],
[1173,2.0,2013,-4.247,50.675,37195,"o"],
[1176,5.2,2013,-3.785,50.424,97159,"o"],
[1184,7.0,2013,-0.864,52.017,130888,"o"],
[1198,4.9,2015,0.055,50.916,91537,"o"],
[1203,7.2,2015,-2.855,51.332,148000,"o"],
[1208,1.0,2012,-2.796,51.358,18456,"o"],
[1223,14.8,2014,1.035,52.604,277050,"o"],
[1226,2.0,2013,-4.074,51.051,37195,"o"],
[1229,2.1,2013,-3.361,50.897,60900,"o"],
[1230,6.2,2013,-4.596,50.391,99300,"o"],
[1232,9.9,2013,1.367,51.352,130400,"o"],
[1233,5.5,2015,-0.849,51.206,123000,"o"],
[1237,2.0,2013,0.745,51.372,37195,"o"],
[1240,1.0,2014,-1.414,52.003,26000,"o"],
[1243,5.0,2017,-2.653,51.645,128000,"o"],
[1244,7.7,2013,-4.901,51.699,144005,"o"],
[1247,5.0,2013,-1.374,51.184,108000,"o"],
[1252,1.7,2012,-1.68,50.762,56000,"o"],
[1269,8.0,2016,-2.58,51.546,149627,"o"],
[1272,1.5,2013,-1.233,51.381,27826,"o"],
[1273,7.2,2013,-1.704,50.757,146000,"o"],
[1274,2.9,2013,-3.306,51.038,54060,"o"],
[1275,5.0,2013,-0.074,52.201,93411,"o"],
[1278,1.2,2014,-1.574,54.548,22204,"o"],
[1282,12.0,2014,-1.151,51.083,223000,"o"],
[1283,3.0,2014,-3.642,50.364,89100,"o"],
[1284,3.0,2014,-1.195,51.733,55934,"o"],
[1285,2.6,2016,-1.112,52.803,48438,"o"],
[1292,4.9,2016,0.403,51.963,117000,"o"],
[1294,5.0,2014,-1.226,53.794,93411,"o"],
[1296,4.8,2016,-6.191,54.558,89663,"o"],
[1298,2.4,2014,-1.098,51.663,44690,"o"],
[1299,3.6,2014,1.168,52.901,79700,"o"],
[1303,3.1,2014,-3.395,50.899,94000,"o"],
[1304,7.2,2014,-2.113,51.626,134636,"o"],
[1306,1.7,2015,-1.022,51.401,40000,"o"],
[1308,6.1,2014,-4.69,50.419,114023,"o"],
[1314,3.5,2014,-2.161,51.273,122000,"o"],
[1315,4.1,2015,-0.078,52.356,79000,"o"],
[1320,1.0,2014,1.231,51.267,25000,"o"],
[1322,10.8,2014,0.391,51.958,180000,"o"],
[1324,4.0,2015,0.453,50.875,74672,"o"],
[1325,12.0,2017,-1.208,50.944,284000,"o"],
[1328,13.9,2014,1.701,52.662,290000,"o"],
[1329,10.2,2014,1.187,52.913,249000,"o"],
[1330,9.0,2014,-3.944,51.794,219000,"o"],
[1331,14.8,2014,-1.348,51.617,277050,"o"],
[1332,18.7,2014,1.124,51.913,350130,"o"],
[1333,5.0,2014,-1.536,51.161,93411,"o"],
[1335,49.6,2016,-2.09,51.373,805000,"o"],
[1338,20.9,2014,0.611,52.289,391356,"o"],
[1339,5.0,2012,-0.561,52.406,93411,"o"],
[1340,1.8,2012,0.388,52.77,31200,"o"],
[1341,3.2,2013,-4.13,50.817,86300,"o"],
[1342,5.0,2012,-1.069,51.214,161900,"o"],
[1343,7.0,2013,-1.485,50.687,117100,"o"],
[1344,5.0,2013,-2.603,50.994,136000,"o"],
[1346,5.2,2013,-4.039,50.922,164000,"o"],
[1348,8.9,2014,-2.945,52.689,166492,"o"],
[1349,8.2,2013,-3.213,51.052,153375,"o"],
[1350,3.8,2015,-5.943,54.669,70925,"o"],
[1352,4.8,2013,-3.359,50.746,89663,"o"],
[1353,6.0,2013,-5.015,50.307,112150,"o"],
[1355,1.5,2013,-2.411,51.044,27826,"o"],
[1356,1.5,2012,-4.138,51.775,27826,"o"],
[1358,2.4,2015,-2.372,57.56,44690,"o"],
[1359,9.2,2014,1.374,51.352,122000,"o"],
[1362,20.5,2014,-1.196,50.831,280000,"o"],
[1367,1.4,2014,-0.072,52.966,25952,"o"],
[1374,4.1,2015,-0.648,51.845,74917,"o"],
[1380,4.8,2015,-3.371,50.634,89663,"o"],
[1382,11.5,2014,1.265,51.235,157300,"o"],
[1384,5.0,2011,-2.091,51.498,93411,"o"],
[1385,6.6,2013,-1.675,51.196,120200,"o"],
[1386,2.0,2011,-3.197,51.061,37195,"o"],
[1387,5.0,2011,0.166,52.345,147600,"o"],
[1388,5.0,2013,-4.796,51.675,107000,"o"],
[1390,1.2,2014,-3.032,53.289,22204,"o"],
[1394,7.6,2013,-2.099,51.561,142131,"o"],
[1404,4.0,2015,-0.995,53.356,87000,"o"],
[1416,3.5,2013,-4.122,50.985,80940,"o"],
[1418,5.8,2013,-1.232,50.918,108402,"o"],
[1421,1.5,2012,-1.422,50.697,27826,"o"],
[1423,1.9,2013,-3.941,50.362,35321,"o"],
[1428,4.0,2016,-4.748,50.563,74672,"o"],
[1429,3.5,2015,-3.262,51.077,83200,"o"],
[1433,4.9,2011,-0.691,52.969,121800,"o"],
[1435,1.2,2013,-4.271,50.61,22204,"o"],
[1439,1.8,2013,-2.312,51.046,43600,"o"],
[1441,1.8,2013,-3.408,50.855,33447,"o"],
[1442,1.4,2013,-3.784,50.831,25952,"o"],
[1443,1.2,2013,-4.215,50.886,22204,"o"],
[1445,1.5,2012,-3.571,50.916,27826,"o"],
[1446,1.0,2013,-4.277,50.752,18456,"o"],
[1449,4.5,2013,-1.034,50.912,132300,"o"],
[1450,1.5,2013,-2.996,51.019,47000,"o"],
[1453,4.0,2013,-2.204,50.923,74672,"o"],
[1454,2.0,2015,-3.227,50.864,37195,"o"],
[1463,21.3,2015,0.937,51.814,398851,"o"],
[1464,5.0,2016,0.602,51.906,93411,"o"],
[1467,6.3,2013,-3.809,50.425,117771,"o"],
[1468,5.0,2013,-2.951,50.773,121300,"o"],
[1473,1.5,2014,-1.316,53.529,27826,"o"],
[1474,5.4,2015,-0.978,51.115,149000,"o"],
[1476,11.0,2014,-2.165,51.482,205843,"o"],
[1478,14.0,2015,-2.596,52.999,286000,"o"],
[1480,8.0,2014,1.285,52.047,149627,"o"],
[1484,10.0,2017,-3.351,50.733,220000,"o"],
[1485,10.2,2015,-2.73,52.657,245000,"o"],
[1489,5.0,2014,-2.507,51.729,150200,"o"],
[1490,1.7,2015,-1.031,53.541,31573,"o"],
[1491,5.8,2014,-2.141,52.633,108402,"o"],
[1494,12.0,2014,0.063,53.02,224582,"o"],
[1497,14.3,2014,-0.993,53.304,273500,"o"],
[1498,12.4,2014,-0.832,52.966,232077,"o"],
[1500,1.8,2014,-1.024,52.36,33447,"o"],
[1501,1.8,2015,-2.389,57.378,29000,"o"],
[1502,19.3,2014,0.157,52.335,350000,"o"],
[1503,3.3,2015,-4.355,51.849,61555,"o"],
[1506,5.0,2018,-3.24,54.139,135000,"o"],
[1507,2.6,2014,0.227,50.92,50300,"o"],
[1509,1.5,2015,-3.087,50.994,44000,"o"],
[1510,1.8,2014,-1.407,52.577,33447,"o"],
[1513,1.4,2011,-2.485,51.868,25952,"o"],
[1515,11.0,2016,-0.95,51.142,222000,"o"],
[1516,10.0,2015,1.124,51.325,210000,"o"],
[1518,8.3,2015,-2.861,51.345,155249,"o"],
[1519,4.1,2014,-1.556,52.251,82000,"o"],
[1520,3.0,2015,-3.059,53.032,55934,"o"],
[1521,2.2,2016,-3.517,51.498,55000,"o"],
[1522,5.4,2014,-2.578,51.209,100906,"o"],
[1523,4.8,2016,-6.199,54.671,89663,"o"],
[1525,10.5,2016,-0.697,53.322,185800,"o"],
[1527,13.2,2014,1.606,52.434,286000,"o"],
[1528,32.5,2014,-0.521,53.015,674700,"o"],
[1529,13.2,2014,-1.426,51.794,255000,"o"],
[1531,10.0,2016,-0.322,50.943,282800,"o"],
[1536,7.6,2016,-0.342,50.946,142131,"o"],
[1537,32.0,2015,1.357,52.755,599355,"o"],
[1538,5.0,2013,-1.367,51.188,93411,"o"],
[1540,3.1,2013,-4.892,50.503,57808,"o"],
[1541,5.0,2013,-4.844,50.504,144900,"o"],
[1542,2.7,2014,-0.148,52.55,50312,"o"],
[1543,4.5,2014,-5.218,50.047,89900,"o"],
[1544,5.0,2013,-5.135,50.122,130000,"o"],
[1545,5.0,2013,-5.121,50.286,93411,"o"],
[1546,5.0,2013,-4.835,50.32,146000,"o"],
[1547,1.6,2012,-4.93,50.49,27900,"o"],
[1548,5.0,2013,-4.93,50.341,93411,"o"],
[1549,3.0,2012,-4.377,50.804,55934,"o"],
[1550,5.0,2012,0.95,52.475,72800,"o"],
[1551,5.0,2012,-4.738,50.48,138000,"o"],
[1552,5.0,2013,-1.116,51.974,154000,"o"],
[1553,5.0,2012,0.221,52.318,178000,"o"],
[1554,5.0,2012,-5.005,50.43,145000,"o"],
[1555,4.6,2013,-0.319,52.774,124300,"o"],
[1557,5.0,2013,-3.925,51.125,93411,"o"],
[1558,5.0,2012,-1.449,50.693,152667,"o"],
[1560,4.9,2013,-4.805,50.424,113800,"o"],
[1561,5.0,2014,-4.449,50.698,151900,"o"],
[1562,5.0,2012,-1.36,50.805,120000,"o"],
[1563,3.6,2012,-4.962,50.494,94500,"o"],
[1564,6.4,2014,-4.326,50.507,173900,"o"],
[1566,7.0,2014,-4.928,50.423,161000,"o"],
[1567,5.0,2013,-2.324,50.7,93411,"o"],
[1569,5.0,2013,-3.346,50.932,158000,"o"],
[1570,5.0,2013,-1.536,51.211,158000,"o"],
[1571,5.0,2012,-0.705,50.837,179200,"o"],
[1572,5.0,2013,-4.423,50.711,156900,"o"],
[1573,5.4,2013,-1.666,51.195,120200,"o"],
[1574,4.8,2012,-2.935,50.779,85600,"o"],
[1575,7.0,2014,-2.586,51.259,130888,"o"],
[1576,2.0,2013,-2.906,50.874,36600,"o"],
[1577,2.0,2015,-3.089,51.562,45100,"o"],
[1578,3.3,2011,-0.697,53.322,61555,"o"],
[1580,2.5,2013,-2.912,51.601,56000,"o"],
[1581,5.0,2011,-0.446,51.06,130000,"o"],
[1582,3.0,2015,-1.205,52.11,77300,"o"],
[1583,5.0,2013,-4.162,50.434,93411,"o"],
[1584,2.5,2013,-4.749,50.397,69900,"o"],
[1585,34.0,2013,-1.112,52.803,754600,"o"],
[1586,3.5,2013,-2.427,51.044,120000,"o"],
[1587,1.2,2012,-3.314,50.946,22204,"o"],
[1588,1.4,2014,-4.778,50.441,25952,"o"],
[1589,5.0,2014,-2.103,50.75,70000,"o"],
[1590,11.0,2014,1.307,52.901,260000,"o"],
[1591,6.4,2013,-4.109,51.064,150000,"o"],
[1592,31.6,2014,0.517,52.131,591859,"o"],
[1593,19.0,2014,-1.73,51.653,359000,"o"],
[1594,5.0,2013,-4.349,50.542,96900,"o"],
[1595,7.2,2015,-5.141,50.304,131000,"o"],
[1598,10.8,2014,-4.952,51.85,202095,"o"],
[1601,7.3,2014,-5.366,50.211,136510,"o"],
[1603,7.5,2014,-3.128,50.926,214000,"o"],
[1604,3.5,2013,-5.387,50.177,63400,"o"],
[1605,1.5,2013,-4.138,51.146,50200,"o"],
[1606,7.6,2013,-2.902,50.935,142131,"o"],
[1607,4.5,2011,0.482,51.32,107600,"o"],
[1609,1.2,2011,-5.056,50.4,41000,"o"],
[1610,3.6,2012,-4.335,50.773,84200,"o"],
[1611,5.0,,-2.506,51.205,93411,"uc"],
[1612,5.4,2012,-2.99,53.041,100906,"o"],
[1614,1.8,2014,-4.545,50.796,33447,"o"],
[1617,1.2,2012,-3.315,50.874,30500,"o"],
[1618,1.1,2012,-3.74,50.852,20330,"o"],
[1619,1.8,2012,-2.095,51.363,44500,"o"],
[1620,6.5,2014,-2.526,51.28,140600,"o"],
[1622,8.6,2013,0.235,53.148,214000,"o"],
[1623,6.0,2012,-4.866,51.899,112150,"o"],
[1626,5.0,2013,-4.378,50.48,105900,"o"],
[1630,41.0,2014,-4.491,50.703,561100,"o"],
[1631,5.0,2013,-4.294,50.802,165000,"o"],
[1634,5.0,2014,-5.044,51.718,123000,"o"],
[1639,5.5,2017,-4.779,50.411,141000,"o"],
[1641,6.5,2015,-4.85,50.568,150000,"o"],
[1642,7.0,2016,-4.929,50.332,161900,"o"],
[1646,5.0,2017,-2.865,51.058,135100,"o"],
[1648,11.8,2014,-4.368,50.803,220834,"o"],
[1649,4.7,2013,-4.141,51.004,87789,"o"],
[1655,6.3,2014,-5.139,50.292,117771,"o"],
[1656,1.0,2014,-1.888,51.628,21000,"o"],
[1658,6.0,2014,0.498,51.856,155600,"o"],
[1659,3.3,2014,-4.12,50.952,61555,"o"],
[1661,4.4,2015,-4.993,51.965,82168,"o"],
[1663,19.8,2014,-2.449,51.534,403000,"o"],
[1667,9.0,2014,-0.559,52.644,187700,"o"],
[1669,3.0,2014,-1.36,50.809,66000,"o"],
[1671,13.0,2015,-1.226,51.844,243320,"o"],
[1672,4.8,2015,0.395,52.594,103300,"o"],
[1673,6.1,2014,0.564,52.559,148100,"o"],
[1681,10.2,2014,-2.945,51.225,266000,"o"],
[1694,22.6,2024,0.192,53.148,340700,"o"],
[1699,5.0,2013,-2.675,51.973,93411,"o"],
[1713,11.5,2013,0.627,52.673,250000,"o"],
[1714,7.9,2013,0.776,52.745,258000,"o"],
[1715,11.0,2013,1.526,52.361,205843,"o"],
[1716,11.5,2013,-1.357,51.636,258200,"o"],
[1717,12.3,2013,1.474,52.352,230203,"o"],
[1718,10.0,2015,-4.946,50.361,187104,"o"],
[1719,18.0,2014,-4.633,51.828,337013,"o"],
[1720,6.4,2014,-3.761,50.42,119645,"o"],
[1721,18.3,2013,-1.144,51.865,342635,"o"],
[1723,1.5,2013,-2.313,50.913,27826,"o"],
[1724,9.3,2013,-1.716,51.592,176000,"o"],
[1725,14.0,2014,-2.111,51.626,262059,"o"],
[1726,1.5,2014,-5.138,50.304,27826,"o"],
[1727,8.0,2014,0.87,51.393,144500,"o"],
[1728,6.8,2013,-4.402,50.701,130000,"o"],
[1729,1.3,2013,-4.095,50.842,31000,"o"],
[1730,5.1,2013,-2.473,53.105,95285,"o"],
[1731,2.2,2013,-1.803,52.02,40943,"o"],
[1732,1.0,2014,-1.475,52.03,26000,"o"],
[1735,41.0,2016,-1.812,51.51,670000,"o"],
[1736,5.0,2014,0.391,52.279,93411,"o"],
[1737,9.0,2014,-0.237,52.419,200800,"o"],
[1743,1.5,2014,-2.437,51.231,27826,"o"],
[1744,1.7,2014,-1.417,52.079,31573,"o"],
[1746,10.5,2016,-2.925,51.835,270000,"o"],
[1747,1.0,2013,-2.822,51.229,22700,"o"],
[1748,6.8,2013,-2.02,51.178,127141,"o"],
[1750,4.8,2013,-3.201,51.007,104700,"o"],
[1751,3.9,2015,1.647,52.34,107000,"o"],
[1752,30.0,2016,-0.735,53.022,523000,"o"],
[1753,10.0,2016,1.606,52.439,187104,"o"],
[1754,7.7,2015,-5.095,50.306,144005,"o"],
[1755,15.0,2014,-0.355,52.972,289100,"o"],
[1756,4.0,2014,-2.486,52.721,117000,"o"],
[1757,13.6,2014,0.789,52.34,226400,"o"],
[1758,10.2,2014,-1.132,50.698,190852,"o"],
[1761,13.2,2014,-1.865,50.847,247068,"o"],
[1762,7.3,2015,-1.138,50.711,136510,"o"],
[1763,10.0,2014,0.39,51.564,299900,"o"],
[1764,6.2,2015,-2.819,51.113,115897,"o"],
[1765,31.3,2014,-4.919,51.819,525000,"o"],
[1766,24.7,2014,-0.198,52.379,580000,"o"],
[1767,11.0,2014,0.806,51.402,190000,"o"],
[1768,48.0,2015,-1.081,50.884,899173,"o"],
[1769,14.6,2015,-0.256,52.149,346000,"o"],
[1772,3.0,2015,-0.559,52.644,73000,"o"],
[1774,4.9,2015,-4.861,51.823,154000,"o"],
[1775,20.0,2014,0.876,50.992,463000,"o"],
[1776,5.0,2014,-4.217,50.442,93411,"o"],
[1777,26.0,2016,0.771,52.862,552200,"o"],
[1781,6.9,2015,-4.029,51.787,210000,"o"],
[1783,30.0,2016,0.197,52.712,673200,"o"],
[1784,5.0,2017,-1.871,51.542,107500,"o"],
[1785,3.8,2015,-0.624,50.806,81000,"o"],
[1787,1.7,2016,-3.696,51.495,45000,"o"],
[1788,3.5,2014,-0.52,52.302,65303,"o"],
[1789,6.5,2017,-6.167,54.609,121519,"o"],
[1804,1.0,2016,-1.776,52.684,21000,"o"],
[1806,1.0,2016,-1.765,52.684,29900,"o"],
[1811,5.0,2017,-1.116,52.74,105000,"o"],
[1813,5.0,2014,-4.663,50.43,93411,"o"],
[1815,5.0,2016,-4.846,50.394,108000,"o"],
[1816,6.6,2014,0.712,51.227,145800,"o"],
[1817,10.0,2014,-1.361,51.633,226300,"o"],
[1818,5.1,2015,-0.927,53.223,88000,"o"],
[1820,6.0,2014,0.544,52.543,135200,"o"],
[1823,7.5,2014,-3.327,51.419,191100,"o"],
[1824,8.3,2015,-4.876,50.351,155249,"o"],
[1826,11.4,2016,0.202,53.143,307800,"o"],
[1827,8.0,2015,-4.524,52.108,168000,"o"],
[1828,7.3,2014,-4.138,51.146,136510,"o"],
[1832,29.0,2015,-1.4,51.605,620000,"o"],
[1834,5.0,2015,-1.881,51.52,117000,"o"],
[1835,38.1,2015,0.27,52.185,631400,"o"],
[1836,8.7,2015,-2.757,51.067,182100,"o"],
[1838,5.0,2016,-1.496,54.175,93411,"o"],
[1840,5.0,2016,-1.612,51.199,110000,"o"],
[1842,5.0,2015,-0.648,51.85,172000,"o"],
[1843,4.9,2015,-1.05,52.918,122000,"o"],
[1846,6.5,2015,-3.75,50.505,135600,"o"],
[1848,4.0,2015,-1.274,51.25,74672,"o"],
[1850,10.5,2016,-1.791,51.524,166300,"o"],
[1862,2.0,2016,-3.498,51.422,53563,"o"],
[1864,5.5,2016,-4.174,51.154,102780,"o"],
[1865,6.8,2015,-0.077,52.356,112900,"o"],
[1872,9.5,2015,-4.379,50.402,177735,"o"],
[1874,8.3,2014,-2.228,50.838,155249,"o"],
[1875,13.1,2014,-0.029,52.119,333000,"o"],
[1876,4.0,2014,-1.861,52.07,74672,"o"],
[1878,5.0,2014,-0.757,52.147,110000,"o"],
[1884,1.2,2017,-4.087,50.811,27185,"o"],
[1885,5.0,2016,-1.259,52.64,97000,"o"],
[1886,8.0,2014,-2.791,51.359,149627,"o"],
[1889,8.6,2016,1.587,52.439,160870,"o"],
[1890,3.3,2014,-1.92,52.102,61555,"o"],
[1892,5.3,2016,-2.603,53.387,99033,"o"],
[1893,2.8,2016,0.944,52.049,52186,"o"],
[1894,4.8,2016,1.039,52.154,89663,"o"],
[1895,7.4,2014,-3.389,51.454,138384,"o"],
[1896,4.8,2015,-4.899,50.356,89663,"o"],
[1897,7.0,2015,-5.121,50.29,130888,"o"],
[1898,6.7,2016,-2.596,50.888,191800,"o"],
[1899,7.0,2014,-1.466,52.067,150700,"o"],
[1900,5.0,2016,-3.765,51.6,93411,"o"],
[1902,5.0,2014,-2.223,50.689,105000,"o"],
[1903,3.6,2015,-2.792,51.043,67177,"o"],
[1904,5.0,2014,-2.318,51.054,161000,"o"],
[1905,14.3,2015,0.341,51.187,266000,"o"],
[1906,14.4,2015,-0.042,52.07,259000,"o"],
[1907,2.7,2014,-1.553,50.74,48500,"o"],
[1908,7.0,2014,-1.349,51.633,131000,"o"],
[1909,7.3,2015,1.389,52.576,168000,"o"],
[1910,5.0,2017,-0.778,52.303,93411,"o"],
[1912,12.6,2015,0.58,51.956,235825,"o"],
[1913,29.9,2015,0.349,52.25,616000,"o"],
[1914,21.0,2014,-2.523,51.54,370000,"o"],
[1915,6.0,2016,-2.011,51.175,101800,"o"],
[1918,7.0,2015,0.12,50.868,203000,"o"],
[1919,16.5,2015,-0.08,52.128,346000,"o"],
[1920,17.0,2015,-1.564,51.481,278300,"o"],
[1923,6.3,2015,-2.219,51.41,141700,"o"],
[1924,22.0,2016,0.781,51.355,391700,"o"],
[1925,6.9,2015,0.808,51.168,201000,"o"],
[1927,5.9,2017,-1.488,54.324,110276,"o"],
[1930,13.0,2016,-3.277,56.368,380000,"o"],
[1931,6.0,2015,-1.26,50.713,183000,"o"],
[1938,4.8,2017,-0.543,51.448,89663,"o"],
[1940,9.3,2014,-0.013,52.008,173987,"o"],
[1942,3.0,2014,-0.463,51.86,55934,"o"],
[1943,8.3,2015,-3.908,51.131,224000,"o"],
[1944,12.0,2015,-2.217,51.494,227300,"o"],
[1945,17.8,2014,-1.791,51.649,403200,"o"],
[1946,11.9,2016,0.994,51.91,168500,"o"],
[1947,7.5,2016,-0.484,52.177,181670,"o"],
[1949,16.0,2014,-0.525,52.303,299536,"o"],
[1950,13.0,2015,1.087,51.822,184000,"o"],
[1951,13.5,2014,-4.038,51.771,252689,"o"],
[1952,7.1,2015,-2.825,51.35,178000,"o"],
[1953,7.7,2015,-3.948,51.701,144005,"o"],
[1954,4.7,2015,-4.25,50.35,81000,"o"],
[1955,20.0,2015,-1.743,52.882,455000,"o"],
[1957,12.0,2015,-0.793,50.764,217000,"o"],
[1958,8.7,2015,-4.037,50.35,162744,"o"],
[1959,4.2,2015,1.136,51.939,103000,"o"],
[1961,8.1,2014,0.499,52.316,153200,"o"],
[1963,8.2,2015,0.175,50.856,304000,"o"],
[1964,5.0,2015,-3.731,50.439,93411,"o"],
[1966,14.5,2014,-0.636,50.814,369000,"o"],
[1968,5.0,2017,-1.667,52.088,185200,"o"],
[1969,6.1,2014,-2.19,51.275,114023,"o"],
[1970,11.3,2016,0.689,51.358,244600,"o"],
[1971,5.3,2015,-4.733,50.484,156000,"o"],
[1973,10.0,2014,-2.165,50.713,157100,"o"],
[1974,8.7,2016,-1.936,51.589,162744,"o"],
[1975,4.0,2021,-3.958,51.687,74672,"o"],
[1976,4.7,2014,-0.811,52.154,110000,"o"],
[1978,5.0,2016,-3.421,50.761,96100,"o"],
[1981,5.0,2014,1.339,51.311,93411,"o"],
[1982,15.0,2015,-3.619,51.523,280797,"o"],
[1983,40.0,2016,-1.46,51.196,749264,"o"],
[1984,12.5,2014,-3.405,50.76,279000,"o"],
[1985,10.0,2015,-3.17,51.635,209000,"o"],
[1987,6.0,2014,-0.692,50.829,153000,"o"],
[1990,6.6,2015,-2.724,52.961,144300,"o"],
[1991,5.0,2015,-1.348,52.63,93411,"o"],
[1992,15.0,2015,-2.531,51.539,280797,"o"],
[1994,1.0,2014,-0.014,52.021,18456,"o"],
[1995,8.2,2015,-2.942,52.687,180000,"o"],
[1998,9.6,2014,-1.986,51.451,322600,"o"],
[1999,2.8,2014,0.72,51.825,52186,"o"],
[2000,12.2,2014,0.72,51.825,228329,"o"],
[2001,2.8,2014,-1.111,51.312,48680,"o"],
[2004,6.0,2016,-2.384,51.198,140000,"o"],
[2005,17.0,2014,-2.435,51.049,310000,"o"],
[2006,10.6,2016,0.976,51.102,252500,"o"],
[2007,19.0,2015,-3.324,54.778,321000,"o"],
[2008,11.0,2014,-5.075,50.304,250000,"o"],
[2009,8.5,2015,-5.169,50.199,158996,"o"],
[2010,5.0,2014,-4.452,50.407,93411,"o"],
[2011,15.8,2015,-1.014,51.418,244000,"o"],
[2012,3.4,2014,-2.623,51.782,75000,"o"],
[2013,15.6,2014,-4.428,50.821,292041,"o"],
[2014,3.7,2015,-0.294,53.274,72000,"o"],
[2015,7.0,2014,-2.924,51.178,187000,"o"],
[2016,6.1,2014,-2.061,50.748,145000,"o"],
[2017,4.2,2015,-1.059,52.936,78420,"o"],
[2019,5.0,2014,-0.064,53.697,138000,"o"],
[2020,5.0,2016,-2.396,51.489,93411,"o"],
[2021,6.5,2015,-3.21,54.175,151800,"o"],
[2022,9.0,2015,-2.034,52.154,205000,"o"],
[2023,13.5,2015,-2.163,51.38,306000,"o"],
[2024,1.3,2014,-1.968,51.371,24078,"o"],
[2026,6.4,2015,-1.391,51.009,153100,"o"],
[2027,37.0,2014,-1.64,51.76,514000,"o"],
[2028,12.0,2014,-4.904,50.353,261800,"o"],
[2030,46.0,2014,-1.374,51.644,786000,"o"],
[2032,11.5,2015,-2.02,52.947,230000,"o"],
[2033,4.1,2015,-3.767,50.293,98800,"o"],
[2034,1.1,2015,1.366,52.137,22517,"o"],
[2035,27.0,2015,-1.7,51.662,504000,"o"],
[2036,4.3,2016,-1.832,52.878,103000,"o"],
[2039,10.7,2014,-2.336,51.185,200221,"o"],
[2040,1.8,2015,-2.658,51.515,59200,"o"],
[2041,4.8,2016,-1.957,52.181,116000,"o"],
[2043,8.9,2015,0.236,50.845,165000,"o"],
[2044,12.0,2017,-1.333,50.891,350000,"o"],
[2045,12.5,2015,-1.182,51.868,238800,"o"],
[2046,20.0,2014,0.83,52.906,374491,"o"],
[2047,3.0,2014,-2.095,50.745,55934,"o"],
[2049,12.7,2015,-1.698,51.598,237699,"o"],
[2050,5.0,2015,1.4,52.689,127400,"o"],
[2051,2.8,2014,-1.787,52.101,75000,"o"],
[2052,5.0,2016,-2.144,50.706,93411,"o"],
[2053,38.0,2023,0.319,51.526,984400,"o"],
[2054,13.9,2015,-1.472,52.707,290800,"o"],
[2055,7.0,2014,-3.399,50.765,141500,"o"],
[2056,5.0,2015,-2.655,51.639,115000,"o"],
[2057,18.7,2015,-1.026,52.781,350130,"o"],
[2058,11.3,2014,-2.098,50.736,169974,"o"],
[2059,1.5,2015,-4.202,50.356,20700,"o"],
[2060,11.5,2016,-2.609,51.014,227400,"o"],
[2061,12.0,2014,-1.881,51.546,227400,"o"],
[2062,5.0,2015,-1.751,51.618,132000,"o"],
[2063,5.0,2014,-2.4,51.821,139000,"o"],
[2064,8.0,2014,-2.925,50.785,223000,"o"],
[2065,24.0,2014,0.218,52.329,449445,"o"],
[2066,11.6,2014,1.287,52.009,254000,"o"],
[2067,5.4,2015,-2.565,51.013,127000,"o"],
[2068,4.3,2016,-0.935,51.748,80294,"o"],
[2071,10.5,2015,-1.294,51.805,182400,"o"],
[2072,5.0,2015,1.104,52.692,147000,"o"],
[2073,6.2,2014,1.348,51.339,165000,"o"],
[2074,24.0,2014,-5.041,51.749,449445,"o"],
[2075,10.0,2016,1.276,51.21,187104,"o"],
[2076,12.5,2016,0.501,52.433,175500,"o"],
[2077,8.1,2015,-2.472,51.597,254500,"o"],
[2078,3.8,2014,-3.025,53.228,70925,"o"],
[2079,7.2,2015,-2.918,52.945,213200,"o"],
[2080,30.0,2016,-2.121,51.959,410100,"o"],
[2081,16.7,2014,-1.105,52.033,350400,"o"],
[2082,12.0,2015,-1.1,51.172,224582,"o"],
[2083,7.7,2016,-2.406,51.644,129000,"o"],
[2084,1.8,2015,-1.364,52.8,33447,"o"],
[2085,34.8,2015,-1.818,51.643,607500,"o"],
[2086,13.0,2015,-1.901,50.861,243320,"o"],
[2088,49.9,2015,0.745,52.791,910575,"o"],
[2089,12.5,2015,-1.608,51.785,284100,"o"],
[2090,7.0,2014,-1.506,51.162,130888,"o"],
[2091,3.5,2014,-2.795,51.13,65303,"o"],
[2092,3.5,2014,-2.784,51.128,65303,"o"],
[2093,6.0,2017,-3.324,51.441,171700,"o"],
[2095,5.0,2015,-3.397,50.824,111000,"o"],
[2096,5.0,2014,-3.243,51.468,66300,"o"],
[2098,1.6,2014,-4.243,50.441,47600,"o"],
[2101,5.0,2015,-3.685,51.019,123300,"o"],
[2102,5.0,2016,-4.405,50.724,93411,"o"],
[2103,5.0,2014,-3.117,51.067,97000,"o"],
[2104,12.6,2014,-4.415,53.179,300000,"o"],
[2105,36.0,2014,-1.856,50.796,767000,"o"],
[2107,8.0,2015,-1.346,53.248,195000,"o"],
[2108,14.4,2016,-2.81,52.824,356000,"o"],
[2109,20.4,2015,-1.883,50.865,381986,"o"],
[2110,13.9,2015,-4.241,53.165,272486,"o"],
[2111,5.0,2016,-1.603,53.012,93411,"o"],
[2112,4.1,2015,-3.382,50.647,76546,"o"],
[2114,7.0,2016,-1.924,50.817,125000,"o"],
[2117,2.6,2016,0.283,51.559,48700,"o"],
[2118,10.0,2015,-2.866,50.937,185000,"o"],
[2120,4.9,2013,-3.222,51.006,91537,"o"],
[2121,10.6,2014,-4.379,50.436,212000,"o"],
[2125,19.5,2016,-4.316,50.474,311200,"o"],
[2126,6.0,2016,-5.183,50.16,98200,"o"],
[2127,2.6,2014,-2.586,51.214,86000,"o"],
[2128,4.0,2015,-0.919,53.303,74672,"o"],
[2129,9.9,2014,-4.366,50.426,238000,"o"],
[2132,5.0,2015,0.111,50.934,91000,"o"],
[2133,3.9,2014,-2.528,51.204,72798,"o"],
[2135,12.0,2015,0.614,51.455,266000,"o"],
[2136,12.5,2014,-1.913,51.724,340000,"o"],
[2137,4.4,2015,-3.407,51.431,107900,"o"],
[2138,7.0,2015,0.813,51.061,144000,"o"],
[2139,3.9,2015,-2.048,50.773,129000,"o"],
[2140,9.0,2015,-0.161,53.144,168366,"o"],
[2143,18.8,2015,0.93,51.943,352004,"o"],
[2144,9.0,2015,-0.693,52.137,177400,"o"],
[2145,4.0,2017,-3.466,50.767,101300,"o"],
[2150,4.2,2016,-1.112,51.328,75300,"o"],
[2151,27.0,2015,-1.0,53.312,574000,"o"],
[2152,16.8,2015,-0.597,52.232,433000,"o"],
[2153,2.3,2014,-2.504,51.352,42817,"o"],
[2154,10.8,2017,-2.777,50.899,218300,"o"],
[2157,4.4,2015,-1.737,52.213,120900,"o"],
[2158,20.0,2015,-2.708,52.735,346600,"o"],
[2159,4.9,2015,-2.039,51.307,144000,"o"],
[2160,4.9,2015,0.297,53.155,91537,"o"],
[2162,4.9,2016,-1.372,53.207,109800,"o"],
[2164,1.2,2014,-2.959,51.017,31800,"o"],
[2165,4.7,2016,-1.299,53.107,87789,"o"],
[2166,1.0,2015,-3.05,52.569,18456,"o"],
[2169,8.1,2015,0.238,50.931,151501,"o"],
[2171,4.7,2015,-0.026,52.53,167400,"o"],
[2173,8.0,2015,-3.393,50.658,189000,"o"],
[2174,1.5,2016,-2.696,51.079,31000,"o"],
[2175,22.0,2016,-1.91,52.072,479700,"o"],
[2176,14.0,2015,-3.158,51.726,286000,"o"],
[2178,1.8,2015,-2.127,52.669,33447,"o"],
[2179,2.0,2015,-2.578,53.771,62000,"o"],
[2180,12.1,2015,-4.942,51.813,264400,"o"],
[2181,5.0,2015,-0.612,51.925,178000,"o"],
[2182,14.0,2015,-0.805,52.127,330000,"o"],
[2184,5.0,2016,-1.343,53.237,101800,"o"],
[2185,2.4,2015,-0.131,52.37,63000,"o"],
[2186,5.0,2017,-0.896,51.748,93411,"o"],
[2187,5.6,2015,0.789,51.837,104654,"o"],
[2188,20.5,2015,-0.798,52.449,383860,"o"],
[2190,11.4,2015,-2.978,51.179,261000,"o"],
[2192,8.0,2015,-1.188,53.26,178300,"o"],
[2196,18.7,2015,-1.685,52.84,350130,"o"],
[2200,16.0,2015,-1.499,52.757,283000,"o"],
[2201,3.0,2015,-2.912,51.222,50500,"o"],
[2202,5.0,2016,-0.022,52.065,93411,"o"],
[2203,69.8,2016,-1.968,51.507,900000,"o"],
[2204,8.0,2016,-0.399,53.028,197000,"o"],
[2205,5.0,2016,-0.78,52.175,114000,"o"],
[2206,8.5,2015,-3.158,51.633,189000,"o"],
[2208,8.1,2015,-0.106,52.926,160000,"o"],
[2210,10.0,2016,-0.951,52.903,194300,"o"],
[2211,10.2,2015,-2.713,52.622,203591,"o"],
[2212,12.3,2015,-2.73,52.633,221475,"o"],
[2213,5.0,2015,-1.16,53.621,145300,"o"],
[2215,7.5,2017,-3.621,51.766,246000,"o"],
[2216,6.2,2015,-0.633,51.872,123000,"o"],
[2217,13.1,2015,-0.739,51.839,248000,"o"],
[2218,10.0,2015,0.226,52.334,271000,"o"],
[2219,31.8,2015,0.049,52.078,545200,"o"],
[2221,5.0,2017,-1.033,53.366,144200,"o"],
[2225,14.0,2015,-4.03,50.408,336000,"o"],
[2226,4.1,2015,-2.988,50.874,103400,"o"],
[2227,9.2,2015,-1.005,51.989,289600,"o"],
[2228,12.0,2015,-0.894,52.039,300700,"o"],
[2231,5.0,2016,-1.021,52.108,93411,"o"],
[2232,4.3,2016,-1.544,52.235,80294,"o"],
[2233,11.6,2015,-2.17,50.818,217086,"o"],
[2234,4.0,2015,-1.864,50.803,72000,"o"],
[2236,13.5,2017,-6.099,54.518,252689,"o"],
[2237,6.1,2016,-1.087,52.81,132000,"o"],
[2238,28.5,2015,-2.362,51.736,404506,"o"],
[2239,24.2,2015,-0.734,51.811,431000,"o"],
[2240,5.0,2016,0.447,51.622,93411,"o"],
[2241,38.0,2015,-0.581,53.56,698000,"o"],
[2242,1.8,2017,-2.51,51.081,33447,"o"],
[2243,4.9,2015,-3.292,51.564,167200,"o"],
[2244,5.0,2015,-0.961,51.39,140700,"o"],
[2247,5.0,2015,-0.848,52.948,93411,"o"],
[2248,5.0,2015,-1.84,50.907,127200,"o"],
[2249,31.6,2015,0.011,52.065,485700,"o"],
[2252,13.0,2015,-4.121,51.11,301700,"o"],
[2253,5.0,2016,-3.525,53.287,93411,"o"],
[2255,48.0,2015,1.099,51.352,899173,"o"],
[2258,5.0,2016,0.191,50.84,151900,"o"],
[2259,1.2,2015,-1.131,51.587,25000,"o"],
[2260,16.0,2015,-1.108,53.241,323000,"o"],
[2261,17.6,2015,-0.923,52.103,329518,"o"],
[2263,6.2,2017,-2.823,54.022,127400,"o"],
[2264,5.0,2016,-1.242,53.703,65000,"o"],
[2265,10.0,2016,-0.482,51.987,362000,"o"],
[2266,9.2,2015,0.412,51.173,252900,"o"],
[2268,5.0,2015,0.843,51.627,120000,"o"],
[2271,19.7,2015,-1.091,53.231,325000,"o"],
[2272,10.7,2017,-2.491,52.529,200700,"o"],
[2274,14.6,2016,-2.981,51.287,366000,"o"],
[2277,6.5,2015,0.095,53.32,121519,"o"],
[2278,14.7,2015,-1.559,52.613,321400,"o"],
[2279,10.4,2015,-1.445,52.214,294100,"o"],
[2280,9.3,2014,-0.793,50.862,124000,"o"],
[2281,17.5,2013,1.41,52.196,327644,"o"],
[2282,20.0,2014,-1.861,50.792,374491,"o"],
[2283,11.3,2014,-1.138,53.224,230500,"o"],
[2284,3.1,2014,1.675,52.449,72500,"o"],
[2285,10.0,2014,-2.17,51.383,187104,"o"],
[2286,11.6,2015,-3.591,51.741,251000,"o"],
[2288,5.0,2015,-4.451,50.751,120000,"o"],
[2296,5.0,2016,-0.683,50.815,93411,"o"],
[2298,5.0,2015,-2.516,51.348,93411,"o"],
[2299,15.0,2015,-0.423,52.268,280797,"o"],
[2300,5.2,2015,1.03,52.603,117000,"o"],
[2307,8.0,2015,-1.132,51.854,141600,"o"],
[2308,18.0,2015,-1.75,50.755,450000,"o"],
[2309,8.1,2015,0.019,53.407,168000,"o"],
[2312,5.9,2016,-0.884,51.288,134000,"o"],
[2314,10.7,2015,-1.443,50.694,189700,"o"],
[2319,5.0,2016,-0.743,52.096,133000,"o"],
[2320,11.9,2015,-1.014,53.155,222708,"o"],
[2321,14.2,2015,-0.88,53.211,236000,"o"],
[2323,18.9,2015,-0.474,53.181,374000,"o"],
[2324,6.5,2017,-6.19,54.608,121519,"o"],
[2325,6.2,2015,-4.908,51.685,161100,"o"],
[2326,8.0,2015,-4.948,51.642,165300,"o"],
[2327,4.7,2017,-3.381,51.673,87789,"o"],
[2329,45.0,2016,-0.069,52.111,1000000,"o"],
[2331,8.0,2015,-3.766,50.386,234000,"o"],
[2332,5.0,2015,-0.133,52.698,93411,"o"],
[2333,21.3,2015,-1.06,51.67,398851,"o"],
[2334,6.0,2015,-3.993,51.7,112150,"o"],
[2335,6.5,2015,-3.534,50.592,121519,"o"],
[2336,5.0,2015,-4.347,50.976,121500,"o"],
[2338,7.0,2016,-3.308,51.418,179017,"o"],
[2342,6.8,2015,-3.36,51.173,127141,"o"],
[2343,20.0,2015,-2.224,51.332,423800,"o"],
[2344,8.0,2015,-1.899,51.605,180000,"o"],
[2345,12.3,2015,-1.738,51.151,242000,"o"],
[2347,72.2,2016,-3.023,53.241,1352648,"o"],
[2348,3.8,2013,-4.92,50.462,83000,"o"],
[2351,14.5,2015,-2.053,51.618,322000,"o"],
[2352,15.0,2015,-0.589,52.253,280797,"o"],
[2353,15.0,2015,-4.405,53.233,300000,"o"],
[2354,6.0,2015,-3.939,51.696,219000,"o"],
[2355,6.7,2015,-4.018,51.795,164000,"o"],
[2356,8.0,2015,-0.929,53.347,220400,"o"],
[2357,13.0,2015,-0.253,52.04,278000,"o"],
[2358,16.6,2015,-2.085,51.308,310779,"o"],
[2359,7.0,2014,-3.405,51.395,163300,"o"],
[2360,10.0,2015,0.226,52.331,271000,"o"],
[2361,5.0,2015,-2.394,50.778,93411,"o"],
[2362,5.1,2015,-1.153,52.053,88000,"o"],
[2363,16.2,2014,-4.178,51.713,288000,"o"],
[2364,5.0,2014,-0.847,52.134,93411,"o"],
[2365,6.1,2015,-4.795,51.747,157000,"o"],
[2366,12.7,2015,0.051,52.746,237699,"o"],
[2367,18.0,2015,1.085,51.357,337013,"o"],
[2368,11.5,2015,0.427,50.873,180000,"o"],
[2369,12.0,2015,-0.429,53.244,224582,"o"],
[2370,13.4,2015,-3.276,51.674,282700,"o"],
[2372,24.0,2014,0.002,52.08,449445,"o"],
[2373,9.1,2015,-2.186,51.342,170239,"o"],
[2375,6.8,2015,-2.904,51.256,127141,"o"],
[2376,6.1,2015,-5.007,51.81,114023,"o"],
[2377,5.7,2015,-1.083,52.99,145300,"o"],
[2378,4.8,2014,-1.025,53.142,89663,"o"],
[2379,17.0,2014,1.144,51.274,221400,"o"],
[2380,8.5,2014,-0.694,52.282,166000,"o"],
[2381,5.0,2014,-3.829,51.609,93411,"o"],
[2382,8.0,2014,-5.197,50.289,180000,"o"],
[2383,9.6,2014,-4.816,50.442,179609,"o"],
[2384,7.0,2015,-2.165,51.543,175000,"o"],
[2385,1.5,2011,0.138,51.508,27826,"o"],
[2386,5.0,2011,-2.689,51.076,107000,"o"],
[2387,1.0,2011,-2.641,51.07,24000,"o"],
[2388,1.8,2011,-0.398,51.404,33447,"o"],
[2389,2.0,2014,-1.536,52.274,37195,"o"],
[4694,6.1,2015,-1.358,52.85,114023,"o"],
[4701,4.5,2017,-2.494,52.335,101000,"o"],
[4703,5.0,2016,-2.495,50.628,73800,"o"],
[4705,2.9,2016,-0.843,52.458,56200,"o"],
[4706,5.0,2016,-0.469,51.856,93000,"o"],
[4712,5.0,2016,-3.167,51.032,109000,"o"],
[4713,10.0,2016,-0.732,50.818,187104,"o"],
[4718,5.0,2015,0.697,51.62,93411,"o"],
[4721,8.9,2015,-5.133,50.181,200000,"o"],
[4724,6.0,2017,-5.569,54.572,112150,"o"],
[4727,8.0,2016,-1.864,50.778,187000,"o"],
[4729,5.0,2015,-2.54,51.146,93411,"o"],
[4734,2.6,2017,-3.18,51.688,48438,"o"],
[4736,3.5,2015,0.162,52.638,91600,"o"],
[4738,1.2,2016,-3.445,52.988,26000,"o"],
[4739,2.7,2017,0.92,52.868,60000,"o"],
[4740,2.4,2015,-4.131,51.15,44690,"o"],
[4745,5.0,2015,-1.316,54.17,101000,"o"],
[4748,1.5,2015,-1.287,52.828,27826,"o"],
[4751,5.0,2016,-2.408,51.667,131500,"o"],
[4752,1.8,2015,-2.937,50.839,28000,"o"],
[4753,1.6,2015,-2.043,57.621,29700,"o"],
[4757,9.5,2015,-2.764,51.224,177735,"o"],
[4761,3.8,2015,-1.872,50.776,74600,"o"],
[4766,5.0,2015,-0.702,50.848,90800,"o"],
[4767,2.5,2015,-1.598,52.759,46564,"o"],
[4769,5.0,2017,-1.817,51.613,93411,"o"],
[4780,3.8,2016,-2.827,57.309,131900,"o"],
[4783,5.0,2016,-1.833,51.048,93411,"o"],
[4785,5.0,2016,-2.684,53.598,120000,"o"],
[4792,4.8,2015,-3.303,50.955,93000,"o"],
[4794,5.0,2017,-3.385,50.878,118000,"o"],
[4804,5.0,2016,-0.316,53.808,93411,"o"],
[4825,5.0,2016,-0.207,52.21,93411,"o"],
[4830,5.9,2015,-4.928,51.824,112000,"o"],
[4833,10.6,2016,-1.245,50.677,190800,"o"],
[4836,1.7,2015,0.654,51.367,31573,"o"],
[4838,5.0,2014,-3.865,51.018,93411,"o"],
[4839,9.5,2015,-4.013,50.447,177735,"o"],
[4840,12.1,2015,-2.167,50.845,223000,"o"],
[4841,2.8,2015,-1.44,52.756,52186,"o"],
[4844,10.0,2016,-2.709,56.574,195200,"o"],
[4846,10.0,2016,0.699,51.37,249000,"o"],
[4850,5.0,2015,-1.931,52.157,110200,"o"],
[4856,8.0,2016,-2.876,51.372,186000,"o"],
[4857,5.0,2015,-0.934,53.636,181000,"o"],
[4858,10.5,2015,-2.575,52.703,131300,"o"],
[4859,5.3,2015,0.394,51.885,109000,"o"],
[4860,4.8,2015,-3.138,50.927,125000,"o"],
[4861,10.0,2015,-2.644,52.938,229600,"o"],
[4862,4.9,2015,-4.479,52.914,91537,"o"],
[4874,7.0,2015,-1.512,51.164,130888,"o"],
[4878,3.0,2015,-4.698,50.467,65900,"o"],
[4880,27.1,2016,-0.146,53.525,365500,"o"],
[4884,5.9,2017,-6.493,54.964,160000,"o"],
[4885,5.0,2016,1.306,52.605,93411,"o"],
[4887,5.0,2016,-2.765,53.873,93411,"o"],
[4889,5.0,2016,-2.318,51.195,98800,"o"],
[4891,2.8,2015,-4.241,50.355,92300,"o"],
[4896,4.0,2017,-4.013,51.637,91500,"o"],
[4897,5.0,2017,-2.639,50.81,93411,"o"],
[4899,1.8,2016,-2.669,51.532,32500,"o"],
[4903,5.0,2016,-3.53,54.614,93411,"o"],
[4916,5.0,2016,-2.392,51.036,92900,"o"],
[4929,1.5,2015,-4.957,50.377,27826,"o"],
[4931,10.0,2015,-0.785,50.758,187104,"o"],
[4933,3.0,2015,-0.545,50.82,52000,"o"],
[4935,5.0,2015,-1.597,54.608,107000,"o"],
[4936,6.6,2016,0.36,51.178,223000,"o"],
[4938,5.5,2014,-4.122,51.759,102780,"o"],
[4939,6.9,2016,-2.372,51.918,155000,"o"],
[4940,5.0,2015,-3.386,51.407,128300,"o"],
[4943,6.8,2015,-2.374,51.92,138000,"o"],
[4948,5.0,2016,-2.233,51.326,132000,"o"],
[4951,5.0,2015,-0.055,53.01,121000,"o"],
[4952,5.0,2015,1.328,51.149,99500,"o"],
[4954,25.7,2018,-6.186,54.506,481301,"o"],
[4969,5.0,2017,-2.704,56.635,100000,"o"],
[4983,2.6,2016,-1.007,53.188,65000,"o"],
[4986,11.0,2017,-0.95,51.142,222000,"o"],
[4990,4.5,2016,-4.125,51.053,101000,"o"],
[4994,5.0,2015,-3.248,50.98,99100,"o"],
[4996,5.0,2015,-1.312,52.643,121500,"o"],
[4997,3.9,2015,-0.194,52.373,92000,"o"],
[5000,1.3,2015,-6.413,54.41,24078,"o"],
[5001,1.3,2015,-3.019,53.909,24078,"o"],
[5002,12.0,2017,0.317,52.328,285000,"o"],
[5006,8.1,2016,-2.946,51.734,151501,"o"],
[5012,1.3,2015,-3.648,55.879,24078,"o"],
[5014,0.5,2017,-2.762,52.389,9087,"o"],
[5015,8.4,2016,-2.06,52.997,137200,"o"],
[5017,5.0,2017,-2.552,54.131,67000,"o"],
[5018,3.0,2017,-1.203,50.943,66700,"o"],
[5019,2.5,2016,-4.746,51.671,42700,"o"],
[5020,25.0,2016,-1.775,52.2,468184,"o"],
[5022,2.6,2016,-1.795,52.916,45600,"o"],
[5026,5.0,2015,-3.07,52.987,106753,"o"],
[5033,5.0,2016,-1.232,54.148,111000,"o"],
[5053,6.0,2016,-2.731,51.634,177649,"o"],
[5063,4.7,2016,-1.657,53.027,108100,"o"],
[5071,1.2,2015,-1.09,50.81,22204,"o"],
[5079,1.5,2015,-4.7,50.471,27826,"o"],
[5080,49.0,2016,-1.53,51.108,776000,"o"],
[5084,8.5,2017,-2.879,51.601,129800,"o"],
[5085,6.0,2017,-6.239,54.742,112150,"o"],
[5089,5.0,2015,1.154,51.912,150000,"o"],
[5090,6.7,2017,-2.09,51.935,100000,"o"],
[5092,5.0,2016,-0.927,52.008,127500,"o"],
[5093,4.5,2015,-3.254,51.396,165000,"o"],
[5096,9.0,2017,-2.556,50.821,168366,"o"],
[5099,5.0,2015,-2.878,54.052,93411,"o"],
[5102,3.0,2016,-2.943,50.886,51200,"o"],
[5104,3.0,2017,-3.293,51.475,82500,"o"],
[5117,5.0,2015,1.307,51.277,93411,"o"],
[5118,22.0,2015,-0.429,53.244,688000,"o"],
[5119,6.2,2016,-1.364,52.8,195400,"o"],
[5125,10.5,2015,1.005,51.861,196474,"o"],
[5128,5.0,2015,-1.374,53.227,93411,"o"],
[5131,5.0,2017,-2.959,50.812,95000,"o"],
[5132,4.2,2016,-2.62,53.792,120000,"o"],
[5136,5.0,2017,-2.675,52.381,135000,"o"],
[5137,4.9,2017,-3.747,50.36,101500,"o"],
[5139,4.0,2016,-1.998,51.98,139000,"o"],
[5140,5.0,2016,-0.168,50.977,117200,"o"],
[5142,5.0,2015,-0.358,51.873,93411,"o"],
[5143,5.0,2017,-1.193,51.38,113600,"o"],
[5145,5.0,2016,-1.653,52.774,117000,"o"],
[5146,5.0,2016,-0.434,51.046,119700,"o"],
[5147,1.0,2016,-2.956,52.959,18456,"o"],
[5148,1.8,2015,-1.744,52.76,39000,"o"],
[5149,5.0,2015,-0.722,52.971,93411,"o"],
[5150,4.0,2015,-3.425,51.524,74672,"o"],
[5152,2.8,2017,-3.761,50.842,87000,"o"],
[5156,5.0,2016,-1.511,52.776,109700,"o"],
[5157,5.0,2015,-1.032,54.096,118000,"o"],
[5158,4.6,2016,-0.655,52.289,105800,"o"],
[5162,5.0,2016,-0.352,51.862,131000,"o"],
[5163,5.0,2017,-2.76,53.846,130000,"o"],
[5164,5.0,2017,-1.333,51.962,93411,"o"],
[5165,5.0,2016,-1.387,53.148,91000,"o"],
[5167,1.7,2015,-0.928,53.348,31573,"o"],
[5168,5.0,2016,-1.317,52.685,93411,"o"],
[5169,8.2,2015,-2.369,52.707,176000,"o"],
[5182,5.0,2015,0.805,51.843,93411,"o"],
[5183,2.3,2016,0.805,51.845,42817,"o"],
[5190,4.4,2016,-4.334,52.907,142200,"o"],
[5199,17.9,2016,1.357,52.755,335140,"o"],
[5202,6.5,2017,-4.786,50.363,121519,"o"],
[5204,5.0,2017,-0.695,53.62,129000,"o"],
[5207,3.5,2016,-2.658,51.561,65303,"o"],
[5212,3.0,2016,-1.691,53.009,55934,"o"],
[5218,1.1,2015,-0.366,51.037,25000,"o"],
[5224,5.0,2016,-1.207,53.256,118000,"o"],
[5225,5.0,2017,-1.087,53.682,129000,"o"],
[5226,3.6,2017,-2.925,53.024,76000,"o"],
[5229,5.0,2016,-1.933,53.013,143000,"o"],
[5230,3.4,2015,-2.623,51.782,75000,"o"],
[5231,8.0,2015,0.991,52.433,149627,"o"],
[5232,5.3,2015,-5.021,51.669,99033,"o"],
[5233,6.4,2015,-4.621,52.092,119645,"o"],
[5234,12.0,2015,-3.635,50.507,224582,"o"],
[5241,6.4,2017,-1.84,52.896,98000,"o"],
[5242,5.0,2016,-1.506,50.99,135000,"o"],
[5243,5.0,2015,-2.536,51.746,157000,"o"],
[5244,5.0,2016,-1.41,52.245,162000,"o"],
[5253,4.6,2016,-1.737,51.605,85915,"o"],
[5255,5.5,,-3.448,51.019,102780,"uc"],
[5256,1.5,2015,-4.563,52.123,27826,"o"],
[5257,10.0,2015,-5.013,51.67,187104,"o"],
[5258,19.5,2015,-0.529,52.304,365121,"o"],
[5259,5.0,2016,-1.479,50.964,93411,"o"],
[5261,2.9,2016,-2.624,53.792,54060,"o"],
[5263,5.0,2016,-0.067,50.999,79800,"o"],
[5264,5.0,2016,-2.26,53.927,112600,"o"],
[5265,4.4,2018,0.848,52.642,82168,"o"],
[5266,5.0,2016,-2.324,52.467,93411,"o"],
[5267,1.1,2016,-0.109,51.11,20330,"o"],
[5271,5.9,2017,-4.281,51.834,138000,"o"],
[5273,5.0,2016,-1.485,52.723,83300,"o"],
[5276,23.0,2022,-1.922,51.711,454700,"o"],
[5282,4.0,2016,-0.922,52.164,111000,"o"],
[5285,5.0,2016,1.25,52.553,102500,"o"],
[5287,5.0,2015,-1.387,53.148,117600,"o"],
[5288,6.2,2016,-1.776,52.874,111000,"o"],
[5289,5.0,2016,-3.239,51.423,133000,"o"],
[5290,4.2,2018,-2.454,50.975,78420,"o"],
[5292,5.0,2016,-3.317,51.746,150559,"o"],
[5293,4.2,2017,-1.055,53.187,100000,"o"],
[5295,5.0,2017,-0.222,51.697,81000,"o"],
[5296,5.0,2016,1.066,52.535,91000,"o"],
[5297,5.0,2017,-1.399,54.237,180000,"o"],
[5301,5.0,2017,-1.485,54.507,93411,"o"],
[5302,4.6,2016,0.039,52.457,85000,"o"],
[5303,2.2,2015,-2.45,53.541,38000,"o"],
[5305,3.5,2015,-1.508,52.595,77500,"o"],
[5309,5.0,2016,-1.076,54.535,101000,"o"],
[5310,4.6,2016,-2.552,51.557,87237,"o"],
[5312,1.7,2015,-2.527,51.522,31573,"o"],
[5315,18.0,2016,-1.752,50.759,337013,"o"],
[5316,2.1,2016,-0.998,52.634,69000,"o"],
[5320,4.8,2016,-1.467,54.921,89663,"o"],
[5321,5.0,2016,-2.876,53.766,122300,"o"],
[5322,5.0,2015,-1.067,53.674,128800,"o"],
[5324,6.8,2017,-2.231,51.29,98000,"o"],
[5328,4.9,2016,-2.96,53.781,120000,"o"],
[5330,6.4,2016,-2.988,54.875,133300,"o"],
[5331,7.0,2017,-6.088,54.513,130888,"o"],
[5332,5.0,2017,-4.743,55.658,122700,"o"],
[5333,5.0,2016,-2.601,56.612,108000,"o"],
[5336,5.0,2016,-2.212,51.292,132400,"o"],
[5340,3.8,2017,-2.866,52.804,60900,"o"],
[5342,6.5,2017,-2.803,52.486,222500,"o"],
[5357,6.0,2017,-1.369,52.664,99600,"o"],
[5359,5.0,2017,-1.355,54.541,93411,"o"],
[5360,3.8,2016,-4.354,52.935,69000,"o"],
[5368,2.7,2016,-1.314,52.684,68600,"o"],
[5371,14.0,,-0.921,51.386,197200,"uc"],
[5376,5.0,2016,-3.06,52.989,103000,"o"],
[5377,3.0,2016,-1.49,52.756,57000,"o"],
[5379,5.0,2016,-2.723,51.587,100000,"o"],
[5380,5.0,2016,-1.737,54.848,111000,"o"],
[5381,4.9,2016,-3.152,51.672,92000,"o"],
[5383,4.0,2016,-1.304,53.264,118000,"o"],
[5384,5.0,2017,-3.151,56.165,73000,"o"],
[5385,5.0,2017,-0.92,52.517,144536,"o"],
[5387,5.0,2016,-0.881,51.28,131000,"o"],
[5389,2.8,2016,-4.097,52.59,52186,"o"],
[5391,5.0,2017,-1.599,52.499,93411,"o"],
[5394,5.3,2016,0.903,51.319,97000,"o"],
[5395,4.1,2016,-4.182,50.412,73500,"o"],
[5396,3.8,2016,-1.197,53.206,66500,"o"],
[5398,1.0,2017,-4.046,51.626,18000,"o"],
[5400,5.0,2016,-1.637,54.357,93411,"o"],
[5401,5.0,2016,-1.216,53.16,178000,"o"],
[5402,5.0,2015,-1.217,53.797,105000,"o"],
[5403,5.0,2016,-1.699,54.417,121000,"o"],
[5404,5.0,2017,-1.254,53.24,120400,"o"],
[5406,3.4,2016,-2.512,53.104,68800,"o"],
[5407,1.2,2016,-1.563,50.739,22204,"o"],
[5411,39.5,2020,0.31,52.293,739894,"o"],
[5412,4.4,2016,-3.002,54.809,120000,"o"],
[5415,5.0,2017,-1.321,53.119,93411,"o"],
[5420,25.7,,-0.24,53.773,481301,"uc"],
[5424,5.8,2017,-1.781,52.876,123000,"o"],
[5425,5.0,2016,-2.419,51.682,93411,"o"],
[5428,5.0,2017,-2.429,50.982,89600,"o"],
[5429,5.0,2017,-2.382,50.972,93411,"o"],
[5430,5.0,2016,1.398,52.798,91000,"o"],
[5431,40.0,2020,-0.36,52.242,749264,"o"],
[5435,10.0,2017,-6.115,54.636,187104,"o"],
[5437,4.1,2017,-3.179,51.704,100600,"o"],
[5440,5.5,2016,-2.962,51.194,155200,"o"],
[5442,2.2,2016,-2.361,51.718,40000,"o"],
[5443,25.2,2017,-6.181,54.56,471932,"o"],
[5444,20.0,2022,-0.134,53.533,340000,"o"],
[5447,5.0,2017,-2.382,53.159,141597,"o"],
[5450,6.5,2018,-6.234,54.694,121519,"o"],
[5451,5.0,2017,-4.03,50.326,119000,"o"],
[5453,5.0,2016,1.398,52.798,126000,"o"],
[5465,5.0,2016,-2.553,52.727,93411,"o"],
[5472,4.2,2016,-1.458,51.156,78420,"o"],
[5477,5.0,2017,-3.314,51.416,115000,"o"],
[5478,3.5,2016,-0.938,52.778,89778,"o"],
[5480,32.0,2021,-2.15,52.069,599355,"o"],
[5482,34.7,2019,-1.228,54.144,740000,"o"],
[5483,5.0,2016,-0.02,53.106,82600,"o"],
[5485,5.0,2016,-4.356,50.402,69400,"o"],
[5486,4.5,2017,-2.962,53.823,112000,"o"],
[5487,5.0,2016,-0.73,50.857,184300,"o"],
[5497,5.0,2016,0.601,51.841,93411,"o"],
[5498,4.0,2017,-2.155,51.322,133100,"o"],
[5499,5.0,2016,-4.534,51.759,106700,"o"],
[5506,15.8,2017,-2.251,52.639,296700,"o"],
[5508,5.0,2017,-2.347,51.057,133000,"o"],
[5512,5.0,2017,-2.306,50.67,93411,"o"],
[5513,4.0,2017,-2.963,56.416,133000,"o"],
[5520,5.0,2016,-1.362,53.281,113782,"o"],
[5523,5.0,2017,-4.988,51.777,171100,"o"],
[5524,5.0,2016,-3.079,51.621,140000,"o"],
[5525,5.0,2017,-2.897,54.819,152000,"o"],
[5527,4.8,2016,-1.804,51.535,89663,"o"],
[5529,5.0,2017,-2.725,52.996,160129,"o"],
[5530,1.2,2016,-1.446,52.725,30000,"o"],
[5531,4.0,2017,-2.992,51.62,94700,"o"],
[5532,4.0,2017,-0.709,52.585,61400,"o"],
[5534,5.0,,-3.025,53.573,81600,"uc"],
[5536,2.8,2017,-2.962,51.27,54700,"o"],
[5538,4.0,2017,-2.286,52.185,89000,"o"],
[5540,5.0,2017,-4.135,52.151,158000,"o"],
[5543,5.0,,1.198,52.638,93600,"uc"],
[5545,1.0,2016,-2.77,52.018,18456,"o"],
[5547,5.0,2017,-4.299,50.754,97600,"o"],
[5548,3.4,2017,-3.53,51.48,63429,"o"],
[5551,7.0,2017,-1.162,51.657,130000,"o"],
[5554,5.0,2016,-1.396,53.147,93411,"o"],
[5559,5.0,2017,-1.201,53.703,114000,"o"],
[5560,5.0,2017,-3.332,51.583,122900,"o"],
[5562,1.5,2016,-0.02,52.965,27826,"o"],
[5568,5.0,2016,-2.142,52.64,93411,"o"],
[5572,4.7,2016,0.344,51.306,87789,"o"],
[5577,5.0,2017,-1.87,52.949,89000,"o"],
[5578,5.0,2016,-0.385,50.952,110000,"o"],
[5581,5.0,2016,-0.599,52.883,160400,"o"],
[5582,4.2,2016,-4.399,50.79,90000,"o"],
[5588,5.0,2017,-3.662,50.351,80200,"o"],
[5590,5.0,2017,-1.552,52.73,110000,"o"],
[5591,3.0,2016,-1.292,53.259,55934,"o"],
[5592,5.0,2016,-1.808,52.888,113000,"o"],
[5593,5.0,,-3.911,51.632,133200,"uc"],
[5596,1.0,2015,-0.962,52.22,18456,"o"],
[5599,5.0,2016,-0.736,51.827,94500,"o"],
[5600,6.2,2016,-2.188,51.02,115897,"o"],
[5602,3.8,2016,-2.422,52.706,70925,"o"],
[5603,17.0,,-1.233,53.017,318275,"uc"],
[5605,5.0,2015,-3.254,51.396,165000,"o"],
[5632,5.0,2017,-2.317,50.688,92600,"o"],
[5633,5.0,2019,0.016,51.125,151100,"o"],
[5643,5.0,2016,-1.418,52.561,100000,"o"],
[5650,5.0,2017,-2.323,50.675,153300,"o"],
[5653,2.5,2016,-1.743,51.6,46564,"o"],
[5654,5.0,2016,-1.051,52.926,124300,"o"],
[5656,5.0,2016,-1.268,54.633,111200,"o"],
[5659,28.5,2024,-2.179,50.687,410000,"o"],
[5660,5.0,2017,-0.205,51.709,101000,"o"],
[5664,4.9,2016,-1.296,54.633,100500,"o"],
[5670,5.0,2016,-2.412,52.709,125000,"o"],
[5683,5.0,2020,-2.993,51.713,114600,"o"],
[5685,5.0,2017,-0.703,52.176,114600,"o"],
[5686,5.0,2016,-2.669,52.139,86100,"o"],
[5687,5.0,2017,-1.204,53.181,116200,"o"],
[5694,5.0,2016,-1.366,54.775,101200,"o"],
[5712,10.0,2017,-1.481,52.254,160000,"o"],
[5720,1.9,2017,1.258,52.645,40000,"o"],
[5723,5.0,2016,-2.376,53.533,129000,"o"],
[5735,3.5,2016,-1.13,52.565,59000,"o"],
[5742,5.0,2017,-1.042,53.127,99700,"o"],
[5756,3.0,2016,-2.058,53.455,55934,"o"],
[5786,5.0,2016,-0.717,50.806,93411,"o"],
[5793,5.0,2016,-2.685,54.286,81000,"o"],
[5795,5.0,2016,-3.712,56.143,120000,"o"],
[5796,2.1,2016,-1.408,52.218,45000,"o"],
[5797,5.0,2017,-3.147,56.148,98000,"o"],
[5824,5.0,2017,0.509,51.159,115000,"o"],
[5828,2.5,2016,-2.171,52.975,46564,"o"],
[5829,5.0,2016,-0.133,52.445,93411,"o"],
[5832,1.0,2017,-0.651,50.823,25000,"o"],
[5834,5.0,2017,-3.015,52.9,134500,"o"],
[5835,4.5,2016,-1.475,51.859,84042,"o"],
[5838,2.5,2017,-2.781,53.707,46564,"o"],
[5844,5.0,,-1.842,54.839,120000,"uc"],
[5845,2.0,,-1.854,57.55,37195,"uc"],
[5848,5.0,2017,-3.526,54.674,141000,"o"],
[5852,4.9,2018,-6.739,54.654,91537,"o"],
[5864,4.2,2016,-2.678,51.508,78420,"o"],
[5866,4.9,2016,-3.1,51.551,91537,"o"],
[5880,6.8,2017,-0.977,52.206,164000,"o"],
[5883,46.0,,-1.567,50.988,720100,"uc"],
[5887,5.0,2016,-0.047,51.907,133000,"o"],
[5891,5.0,2017,-2.556,50.822,170000,"o"],
[5914,5.0,2018,-2.586,56.604,120000,"o"],
[5917,1.4,2015,-4.09,51.668,25952,"o"],
[5926,4.7,2016,-2.214,51.28,105200,"o"],
[5928,5.0,2017,-2.93,53.775,97000,"o"],
[5938,5.0,,-3.028,53.57,73300,"uc"],
[5942,5.0,2017,0.423,51.472,67600,"o"],
[5945,1.2,2015,-2.824,57.308,22204,"o"],
[5946,2.5,2016,0.694,51.575,32000,"o"],
[5952,8.5,2018,-6.262,54.402,158996,"o"],
[5955,25.0,2017,-6.44,54.999,490000,"o"],
[5977,6.4,2018,-6.016,54.675,150000,"o"],
[5985,1.0,2016,0.027,51.492,18456,"o"],
[6007,13.0,2018,-6.254,54.884,180000,"o"],
[6019,5.8,2017,-2.798,54.668,142000,"o"],
[6035,3.8,2017,-3.7,51.54,70925,"o"],
[6042,1.4,2016,-2.571,51.525,25952,"o"],
[6043,1.8,2016,-2.571,51.525,33447,"o"],
[6055,1.8,2015,-0.215,50.828,33447,"o"],
[6062,2.4,2015,-2.395,50.776,44690,"o"],
[6063,6.3,2016,-0.31,51.39,117771,"o"],
[6069,2.5,2018,-1.814,51.574,46564,"o"],
[6071,49.9,,-4.42,53.406,728460,"uc"],
[6108,5.0,2017,-4.988,51.774,171100,"o"],
[6114,1.8,2016,-0.009,51.679,33447,"o"],
[6129,2.4,2016,-1.242,53.703,65000,"o"],
[6132,1.7,2016,-0.408,51.496,31573,"o"],
[6133,4.9,2017,-0.795,52.205,182000,"o"],
[6162,1.6,2016,-2.427,53.58,29700,"o"],
[6163,11.0,2016,-1.479,50.964,205843,"o"],
[6172,5.0,2016,-2.921,53.029,100000,"o"],
[6174,3.2,2016,-0.097,52.932,65000,"o"],
[6180,5.0,2016,-0.137,52.451,100200,"o"],
[6181,5.0,2016,-0.981,53.445,158400,"o"],
[6189,1.2,2016,-2.817,54.021,22204,"o"],
[6198,1.0,2017,-0.952,51.006,18456,"o"],
[6205,5.0,2016,-0.606,50.834,99300,"o"],
[6230,5.0,2016,-2.81,53.772,113000,"o"],
[6231,1.7,2016,-2.807,53.772,33600,"o"],
[6244,7.5,2018,-0.743,50.847,158800,"o"],
[6246,2.9,2018,-2.472,53.106,54060,"o"],
[6248,14.2,2021,0.711,52.319,265807,"o"],
[6314,1.0,2017,-2.009,52.507,18456,"o"],
[6320,1.0,2017,-0.007,51.522,18456,"o"],
[6321,4.0,2016,-1.378,54.591,92000,"o"],
[6328,2.0,2018,-4.095,50.968,37195,"o"],
[6329,1.9,2017,-1.498,50.932,35321,"o"],
[6369,5.0,2016,-3.471,51.398,107000,"o"],
[6376,1.0,2016,0.91,50.935,18456,"o"],
[6402,5.0,2017,-1.571,53.712,93411,"o"],
[6403,2.5,2016,-1.033,53.538,46564,"o"],
[6411,75.0,2021,-2.903,51.561,1214100,"o"],
[6456,40.0,,-0.466,53.184,749264,"uc"],
[6458,1.4,2017,-1.915,52.101,20000,"o"],
[6466,1.3,2019,-2.826,53.751,26000,"o"],
[6484,7.0,2021,-1.351,52.355,130888,"o"],
[6485,5.0,2016,-0.525,54.179,93411,"o"],
[6486,1.5,2016,-3.118,51.5,27826,"o"],
[6493,5.7,2017,-2.721,51.611,157500,"o"],
[6502,373.0,2025,0.914,51.339,6989235,"o"],
[6506,18.0,2017,-6.515,54.959,337013,"o"],
[6513,2.5,2019,-2.825,53.569,87000,"o"],
[6520,3.8,2017,-3.671,51.512,98000,"o"],
[6523,3.2,2019,-2.832,53.75,63000,"o"],
[6530,25.0,,-0.366,52.976,503000,"uc"],
[6532,7.2,2019,-2.866,53.17,135000,"o"],
[6560,1.0,,-2.604,53.36,18456,"uc"],
[6591,7.3,2020,-3.976,50.333,109000,"o"],
[6603,1.0,2018,-0.612,52.067,18456,"o"],
[6660,8.9,2020,-3.126,51.494,168900,"o"],
[6683,1.2,2016,0.42,52.74,22204,"o"],
[6700,44.0,2022,0.365,51.963,824218,"o"],
[6701,20.0,,-0.413,52.968,675900,"uc"],
[6716,4.2,2022,-4.637,50.646,81600,"o"],
[6720,20.0,,-1.166,52.411,255100,"uc"],
[6723,4.0,2019,0.353,51.468,74672,"o"],
[6726,1.9,2019,-3.391,56.064,35321,"o"],
[6736,36.6,,-1.913,57.589,507500,"uc"],
[6742,0.2,2020,-2.381,51.635,3465,"o"],
[6745,0.3,2020,-3.239,56.182,4500,"o"],
[6748,0.5,,-1.421,52.253,9087,"uc"],
[6752,0.8,2020,-2.297,51.753,14709,"o"],
[6759,0.5,2019,-2.763,54.357,9087,"o"],
[6761,0.5,2019,-2.369,51.866,9087,"o"],
[6762,1.0,2021,0.538,52.669,20347,"o"],
[6766,4.9,2020,-1.363,52.691,106400,"o"],
[6768,0.5,2020,-5.019,51.76,9087,"o"],
[6816,0.38,2019,-2.111,51.999,6838,"o"],
[6834,10.0,2023,-3.911,51.632,191300,"o"],
[7210,4.9,2020,-1.485,54.918,91537,"o"],
[7222,3.0,,-3.196,55.869,57700,"uc"],
[7225,0.2,2020,-1.432,53.54,3465,"o"],
[7229,0.2,2020,-0.67,50.797,3465,"o"],
[7232,19.9,,-4.628,55.596,372617,"uc"],
[7235,0.2,2019,0.304,50.786,3465,"o"],
[7238,0.4,2020,0.76,51.443,7213,"o"],
[7244,0.2,2019,-0.812,52.019,3465,"o"],
[7247,0.4,2019,0.502,51.563,7213,"o"],
[7248,1.5,2020,-2.659,53.407,27826,"o"],
[7249,0.3,2020,-0.453,51.769,5339,"o"],
[7251,0.5,2020,-2.489,53.523,9087,"o"],
[7252,1.2,,-1.801,51.51,22204,"uc"],
[7256,49.9,2021,-0.824,53.051,934776,"o"],
[7258,18.3,2022,-1.255,52.44,341400,"o"],
[7259,0.3,2020,-3.518,55.914,5339,"o"],
[7267,0.2,2020,-3.409,56.019,6000,"o"],
[7269,0.4,2020,-0.04,52.135,7213,"o"],
[7274,0.5,,-4.252,57.694,9087,"uc"],
[7279,0.3,2019,-3.031,53.593,3800,"o"],
[7281,0.3,2019,-5.078,56.837,5339,"o"],
[7287,0.4,2021,-3.385,56.383,7213,"o"],
[7288,0.2,2020,-1.533,53.788,3465,"o"],
[7290,2.0,,-0.246,51.774,37195,"uc"],
[7292,0.7,2020,-2.174,53.462,12835,"o"],
[7298,0.2,2019,0.097,52.661,3465,"o"],
[7310,0.2,2019,-4.167,57.693,4170,"o"],
[7320,0.2,2019,-1.132,52.654,3465,"o"],
[7321,0.3,2019,-2.637,50.942,5339,"o"],
[7330,0.9,,-0.065,52.322,16582,"uc"],
[7347,1.8,2020,-3.462,56.384,33447,"o"],
[7363,28.0,2023,0.319,52.319,481000,"o"],
[7374,1.0,2020,-0.216,51.905,18456,"o"],
[7375,5.0,2020,-2.972,54.93,93411,"o"],
[7381,0.3,2019,-1.015,51.728,5339,"o"],
[7384,32.0,,-1.404,51.781,634000,"uc"],
[7386,0.2,2020,-0.981,51.989,3465,"o"],
[7391,0.2,2019,-4.014,55.854,3465,"o"],
[7400,2.0,2021,-3.139,53.256,47000,"o"],
[7405,18.0,2022,-2.008,51.179,337013,"o"],
[7409,4.4,2022,-2.259,52.996,137200,"o"],
[7410,0.6,,-1.159,51.891,10961,"uc"],
[7423,8.0,2021,-2.145,52.073,186000,"o"],
[7425,49.9,2025,-1.51,51.248,800000,"o"],
[7448,0.5,2020,-0.046,53.539,9087,"o"],
[7451,35.0,2025,-3.372,50.823,607800,"o"],
[7478,0.58,2021,-4.128,51.201,10586,"o"],
[7482,29.4,,0.316,52.323,737400,"uc"],
[7497,19.0,,-1.127,51.852,470000,"uc"],
[7508,1.0,,-2.644,51.863,13800,"uc"],
[7519,49.9,,-1.738,51.615,955200,"uc"],
[7526,0.3,2020,-2.221,57.201,5339,"o"],
[7531,1.0,2021,-2.89,56.366,18456,"o"],
[7539,19.8,,-2.859,51.353,399900,"uc"],
[7541,0.4,2020,1.389,51.378,7213,"o"],
[7542,0.4,,0.916,51.141,7213,"o"],
[7559,0.4,2021,-0.219,54.063,7213,"o"],
[7561,49.9,,-0.942,53.345,659600,"uc"],
[7596,5.0,,-1.841,57.566,116000,"uc"],
[7599,1.4,2021,-1.921,51.688,24000,"o"],
[7604,1.1,2022,0.18,52.298,21000,"o"],
[7630,49.9,,0.304,52.284,807000,"uc"],
[7646,0.2,2021,0.829,52.57,3465,"o"],
[7666,24.0,2024,0.663,52.078,449445,"o"],
[7689,0.9,2019,1.105,51.785,16582,"o"],
[7714,1.5,,1.395,52.088,29000,"uc"],
[7735,2.4,2021,-1.271,53.601,44690,"o"],
[7738,1.9,,-2.438,53.527,37900,"uc"],
[7741,0.9,,-2.155,53.516,15000,"uc"],
[7745,0.2,2021,-2.807,55.895,3465,"o"],
[7758,0.18,2021,-4.282,55.836,3091,"o"],
[7763,0.2,2022,-3.409,55.931,3465,"o"],
[7766,2.1,,-2.764,50.861,39069,"uc"],
[7781,12.0,2022,-3.873,50.754,184000,"o"],
[7782,0.3,2021,-2.453,53.756,5339,"o"],
[7795,1.0,2020,-2.697,51.325,18456,"o"],
[7818,2.3,,-0.439,53.876,42817,"uc"],
[7819,0.2,2022,-1.08,52.599,3465,"o"],
[7834,1.6,2021,-3.054,53.22,32000,"o"],
[7840,49.9,2023,-2.156,52.088,1077000,"o"],
[7883,0.2,2021,-0.483,50.99,3465,"o"],
[7889,49.9,,-0.174,53.56,1340000,"uc"],
[7915,0.3,2021,-3.388,56.383,5833,"o"],
[7928,0.2,2021,1.347,52.759,3465,"o"],
[7929,35.0,2025,-2.6,50.908,555900,"o"],
[7943,0.2,2020,-3.184,55.952,3465,"o"],
[7944,49.9,,-2.497,51.545,900000,"uc"],
[7954,49.9,,-1.136,52.36,808600,"uc"],
[7958,22.0,2023,-0.901,51.963,469700,"o"],
[7968,1.2,2021,-2.418,52.683,16000,"o"],
[7971,0.3,2021,-1.453,52.72,5339,"o"],
[7972,0.2,2021,-0.138,52.231,3465,"o"],
[7976,0.3,2020,-2.72,53.768,5339,"o"],
[8010,30.0,,1.028,52.497,384100,"uc"],
[8011,25.0,2023,-1.347,51.114,450000,"o"],
[8013,5.5,,-0.47,52.132,102780,"uc"],
[8023,25.0,2024,0.661,51.704,363400,"o"],
[8026,49.9,,0.34,51.539,1680000,"uc"],
[8029,0.5,,-2.347,53.386,9087,"uc"],
[8030,0.7,2023,-2.192,53.485,12835,"o"],
[8051,70.0,2023,-2.477,51.578,1060000,"o"],
[8053,49.9,,0.181,53.099,737200,"uc"],
[8062,49.9,,-2.138,51.406,963200,"uc"],
[8067,0.2,2023,-3.878,51.618,3465,"o"],
[8069,5.0,,-1.359,51.848,112500,"uc"],
[8094,23.0,,-1.811,50.89,388400,"uc"],
[8101,49.9,,-4.121,51.045,934776,"o"],
[8131,55.0,2024,-1.699,54.411,695000,"o"],
[8136,49.9,2026,-2.03,51.66,934776,"o"],
[8141,0.5,2021,-2.758,54.352,9087,"o"],
[8146,40.0,2023,-2.726,52.976,651100,"o"],
[8148,28.5,,1.212,52.562,533769,"uc"],
[8149,49.9,,-0.956,51.3,700900,"uc"],
[8165,0.5,2021,-2.8,53.559,9087,"o"],
[8167,40.0,,-1.365,53.757,877600,"uc"],
[8178,0.2,2021,-1.893,52.286,3465,"o"],
[8201,0.15,2021,-4.131,50.555,2528,"o"],
[8202,2.3,2021,-1.539,55.133,33500,"o"],
[8203,0.49,2021,1.076,52.861,9000,"o"],
[8204,0.18,2021,-1.235,54.574,3091,"o"],
[8205,0.62,2021,-2.992,56.323,11336,"o"],
[8210,0.15,,0.049,52.501,4900,"uc"],
[8212,0.49,,-1.217,52.647,6852,"uc"],
[8222,0.62,,-1.078,52.879,11336,"uc"],
[8223,0.17,2021,0.463,51.92,2903,"o"],
[8228,30.0,,-2.003,52.162,561877,"uc"],
[8233,0.25,2021,-2.614,56.775,6000,"o"],
[8234,0.2,,-0.029,51.658,3465,"uc"],
[8251,49.0,2024,0.846,51.847,968000,"o"],
[8257,19.94,,-1.953,51.691,737200,"uc"],
[8259,0.3,,-2.94,52.248,5339,"uc"],
[8272,0.5,2021,-0.314,52.281,7900,"o"],
[8336,26.0,,-1.096,52.71,462500,"uc"],
[8357,49.9,2024,0.377,51.59,934776,"o"],
[8405,0.19,2021,-0.158,51.106,3278,"o"],
[8408,1.15,2022,0.194,52.487,21267,"o"],
[8411,49.9,,0.322,51.541,1430000,"uc"],
[8440,1.0,2021,-2.762,54.356,18456,"o"],
[8448,0.35,2021,0.998,51.262,6276,"o"],
[8452,0.96,,-2.352,53.196,17707,"uc"],
[8457,0.5,2021,0.433,51.163,9087,"o"],
[8479,49.9,2023,0.349,52.292,730000,"o"],
[8529,49.9,,-1.575,54.543,934776,"uc"],
[8799,1.62,2022,-1.31,51.571,30074,"o"],
[8802,42.0,2025,-4.42,50.791,663300,"o"],
[8811,0.44,2021,-0.631,52.07,14200,"o"],
[8824,19.0,2025,0.286,52.008,549200,"o"],
[8855,0.15,2021,-1.862,52.082,2528,"o"],
[8856,10.0,,-1.709,52.866,187104,"uc"],
[8857,5.0,,-0.632,53.676,131000,"uc"],
[8858,5.0,2023,-1.951,50.77,117000,"o"],
[8897,19.6,,-1.375,53.108,379000,"uc"],
[8928,0.3,2021,-2.762,54.356,5339,"o"],
[9002,10.2,,0.366,51.29,190500,"uc"],
[9014,49.99,,-0.808,53.907,1350000,"uc"],
[9038,30.0,2026,-1.851,52.116,561877,"o"],
[9051,2.5,2022,-4.065,52.425,39200,"o"],
[9065,5.0,,-2.939,56.654,80000,"uc"],
[9090,36.0,,-1.504,51.764,674309,"uc"],
[9110,0.22,2022,-2.649,50.942,3840,"o"],
[9142,10.0,,-5.074,50.348,187104,"uc"],
[9150,0.6,2021,-2.199,53.469,10961,"o"],
[9157,0.67,2023,-2.073,52.355,12273,"o"],
[9164,1.0,,-1.56,54.306,18456,"uc"],
[9173,34.8,,-1.426,52.237,670000,"uc"],
[9179,5.0,2022,-0.45,53.77,77300,"o"],
[9190,0.18,2022,-5.542,50.112,3091,"o"],
[9193,9.7,,0.0,52.955,176700,"uc"],
[9198,0.2,2021,1.388,51.367,3465,"o"],
[9236,1.2,,-1.088,50.812,22204,"uc"],
[9237,49.9,,-2.172,51.509,878600,"uc"],
[9247,45.0,2024,-2.629,52.066,1200000,"o"],
[9253,1.97,2022,-0.656,52.041,36633,"o"],
[9272,0.15,,-2.202,53.503,2528,"o"],
[9273,49.99,,0.689,51.628,669300,"uc"],
[9282,35.0,2024,0.624,51.865,658000,"o"],
[9326,0.35,2021,-1.177,52.94,6276,"o"],
[9351,0.26,2021,0.181,51.605,4590,"o"],
[9360,40.0,2022,-2.141,50.813,715000,"o"],
[9367,0.63,,-0.676,52.502,11523,"uc"],
[9372,16.5,,-2.796,54.028,214400,"uc"],
[9382,1.7,2021,-0.341,51.059,31573,"o"],
[9394,49.99,,-1.679,52.123,936463,"uc"],
[9412,0.7,,-4.163,50.369,12835,"uc"],
[9420,0.56,2021,-2.639,53.345,9900,"o"],
[9500,4.19,,-3.027,56.199,54600,"uc"],
[9503,14.3,,0.266,51.888,225000,"uc"],
[9523,1.03,,-2.049,57.691,19019,"uc"],
[9524,40.0,,0.199,52.723,560000,"uc"],
[9527,6.9,,-2.094,52.592,145700,"uc"],
[9541,0.8,,-3.531,51.494,14709,"uc"],
[9542,32.0,,-0.425,54.249,477400,"uc"],
[9570,0.17,,-2.237,53.469,3411,"uc"],
[9578,3.99,,-2.213,53.59,107000,"uc"],
[9610,49.9,,1.077,52.084,850000,"uc"],
[9631,28.7,2024,-1.569,52.212,537517,"o"],
[9632,0.16,2021,-0.071,51.542,2716,"o"],
[9664,0.53,2021,-4.153,51.097,9649,"o"],
[9671,0.18,2021,-0.046,51.612,3091,"o"],
[9681,33.0,,1.318,51.331,618093,"uc"],
[9749,3.0,2024,0.386,51.28,48000,"o"],
[9755,3.0,,-1.699,55.038,55934,"uc"],
[9767,0.62,2022,0.744,52.24,11336,"o"],
[9785,32.0,,-4.141,51.006,632788,"uc"],
[9802,30.0,,0.598,51.581,452000,"uc"],
[9845,0.8,2022,-2.847,53.486,14709,"o"],
[9941,17.87,,-0.962,51.328,300000,"uc"],
[9951,0.55,2022,-0.398,51.402,10024,"o"],
[9962,45.0,2024,-2.627,52.053,842957,"o"],
[10001,0.19,2022,0.639,51.81,3278,"o"],
[10005,0.29,,1.161,51.085,5152,"o"],
[10016,18.0,2025,-1.484,52.195,337013,"o"],
[10035,32.0,,-2.974,51.798,701700,"uc"],
[10040,18.9,,-2.953,50.777,273900,"uc"],
[10088,24.0,,-2.978,51.161,360000,"o"],
[10089,30.0,,-2.511,52.684,530000,"uc"],
[10140,0.75,,-4.153,51.097,12200,"uc"],
[10149,0.62,2022,-1.321,52.977,11336,"o"],
[10296,0.17,,0.876,51.148,2903,"o"],
[10303,0.36,,-0.07,53.576,6464,"uc"],
[10369,49.9,2025,0.292,51.511,900000,"o"],
[10412,0.15,2022,-4.193,51.011,2528,"o"],
[10415,9.9,2023,-5.003,51.703,146700,"o"],
[10417,25.0,,-2.428,52.745,363600,"uc"],
[10422,1.16,,-2.134,53.449,21455,"o"],
[10443,0.8,2022,-1.731,53.825,14709,"o"],
[10458,1.9,2022,-1.541,54.839,43700,"o"],
[10469,14.2,,-1.856,57.463,191000,"uc"],
[10471,0.17,,-1.072,54.616,2903,"uc"],
[10549,19.9,,-4.428,55.864,299000,"uc"],
[10577,49.9,,0.435,51.149,692300,"uc"],
[10654,0.17,,-3.566,50.424,2903,"uc"],
[10692,1.18,2022,-2.343,53.791,21829,"o"],
[10755,0.84,,-2.837,51.391,15458,"uc"],
[10758,0.62,2022,0.103,51.506,11336,"o"],
[10776,0.19,2022,-1.921,52.303,3278,"o"],
[10778,25.6,,0.467,51.61,442200,"uc"],
[10780,0.34,2022,0.862,52.553,6089,"o"],
[10790,1.66,2023,-1.178,52.262,30824,"o"],
[10797,49.9,2025,-2.345,51.908,1160500,"o"],
[10809,2.5,,-2.348,53.272,46564,"uc"],
[10868,0.7,2022,1.109,52.373,12835,"o"],
[10944,30.0,,1.09,52.647,537300,"uc"],
[10988,1.34,,-1.362,54.77,24827,"uc"],
[11017,1.0,,-1.356,52.963,18456,"uc"],
[11070,0.27,2023,-0.964,53.587,4777,"o"],
[11080,0.92,,-2.191,53.485,16957,"uc"],
[11086,0.18,,-0.964,53.587,3091,"uc"],
[11101,0.34,,-4.862,55.943,6089,"uc"],
[11155,0.65,2023,-3.149,56.12,11898,"o"],
[11177,21.0,,-2.064,57.313,360000,"uc"],
[11263,29.9,,-3.465,56.1,461000,"uc"],
[11271,0.16,2022,-1.093,53.973,2716,"o"],
[11291,0.27,2022,-2.174,53.406,4777,"o"],
[11329,49.99,,0.603,52.052,936463,"uc"],
[11330,8.8,2022,-0.919,52.241,164618,"o"],
[11335,0.24,2022,-0.498,53.558,4215,"o"],
[11359,3.0,,-1.275,53.602,55934,"uc"],
[11366,30.0,,-3.36,50.733,747700,"uc"],
[11384,9.88,,-3.545,51.74,161300,"uc"],
[11410,0.91,,-1.775,51.598,16770,"uc"],
[11419,0.62,,-1.414,53.027,11336,"uc"],
[11423,26.0,,-0.671,52.279,651500,"o"],
[11486,5.2,2025,0.405,51.581,68800,"o"],
[11491,2.0,,-1.032,52.304,30000,"uc"],
[11499,0.61,,-0.241,51.688,11148,"uc"],
[11509,8.94,,-3.554,51.744,120034,"o"],
[11513,2.6,2024,-1.318,52.656,48438,"o"],
[11567,0.22,2023,-2.885,53.26,3840,"o"],
[11589,5.56,,-1.922,55.472,103905,"uc"],
[11646,1.0,,-2.171,51.846,18456,"uc"],
[11711,0.43,,-0.316,51.439,7775,"uc"],
[11755,1.04,,-1.249,50.871,19206,"uc"],
[11756,49.0,,-3.341,50.806,704000,"uc"],
[11799,23.0,,-2.271,52.617,547000,"o"],
[11815,0.63,,-2.94,53.513,11523,"uc"],
[11975,0.9,,-1.129,52.72,16582,"uc"],
[12050,0.24,2022,-1.546,52.768,4215,"o"],
[12054,0.22,2023,-1.533,53.803,3840,"o"],
[12078,0.26,,-0.717,52.073,4590,"uc"],
[12101,40.0,,0.799,51.859,870000,"o"],
[12117,75.0,,-0.211,52.922,973000,"uc"],
[12137,49.9,,-1.431,52.197,825000,"o"],
[12271,0.94,,-4.215,55.765,17332,"uc"],
[12273,40.0,,-4.544,55.433,582000,"uc"],
[12300,31.0,,-1.337,53.258,650000,"o"],
[12314,0.63,2023,-2.704,54.75,11523,"o"],
[12335,0.3,2020,-2.663,51.05,5339,"o"],
[12393,0.33,,-2.272,51.032,5901,"uc"],
[12397,0.17,,-2.272,51.032,2903,"uc"],
[12398,0.16,,-2.272,51.032,2716,"uc"],
[12399,0.62,,-2.272,51.032,11336,"uc"],
[12439,0.65,,-1.221,53.793,11898,"uc"],
[12450,0.55,,0.7,52.249,10024,"uc"],
[12507,2.5,,-1.177,53.581,46564,"uc"],
[12597,25.0,,-1.453,52.458,468184,"uc"],
[12623,15.0,,-0.588,51.916,301300,"uc"],
[12663,0.19,,-0.748,50.821,3278,"uc"],
[12682,2.04,2024,0.438,52.076,37945,"o"],
[12720,0.89,,-0.017,52.962,16395,"uc"],
[12728,1.1,2023,0.271,50.787,20330,"o"],
[12758,0.22,,-2.397,53.841,3840,"uc"],
[12764,0.25,,-0.351,51.455,4402,"uc"],
[12802,0.88,2023,-0.635,52.068,16208,"o"],
[12922,0.23,,-3.812,55.814,3992,"uc"],
[12927,0.31,,-1.768,53.661,5527,"uc"],
[12934,0.8,2023,-1.682,55.153,14709,"o"],
[12947,1.0,,-0.483,52.441,18456,"uc"],
[12972,6.5,,-4.331,50.976,103000,"uc"],
[13014,5.0,,-3.417,50.864,66600,"uc"],
[13025,6.15,2023,0.754,51.807,106400,"o"],
[13030,7.5,,-4.674,55.613,243300,"uc"],
[13054,3.81,,-2.657,51.515,52000,"uc"],
[13104,1.3,2022,-0.543,51.395,24078,"o"],
[13131,0.8,2023,-3.387,54.705,14709,"o"],
[13162,0.15,2023,-0.865,52.221,2528,"o"],
[13250,5.0,,-4.651,55.598,186800,"uc"],
[13251,26.0,2023,-1.214,52.433,552000,"o"],
[13370,1.12,2024,-0.101,53.575,20705,"o"],
[13381,1.08,2024,-0.121,53.575,16036,"o"],
[13443,0.19,2022,-2.137,53.974,3278,"o"],
[13475,0.18,2023,-1.135,52.946,3091,"o"],
[13519,0.86,,-0.349,53.231,12900,"uc"],
[13697,1.7,,-1.146,52.672,31880,"uc"],
[13791,6.0,,-3.419,51.567,168900,"uc"],
[13882,0.22,,-2.344,51.386,3840,"uc"],
[13932,0.22,,0.079,51.53,3840,"uc"],
[13973,0.48,,-2.315,53.482,8712,"uc"],
[14068,0.3,,-2.598,52.316,5339,"uc"],
[14202,0.16,2023,-3.844,56.768,2716,"o"],
[14217,0.86,,-4.13,55.894,15833,"uc"],
[14237,0.7,,-2.942,53.822,12835,"uc"],
[14267,0.18,,-4.575,56.004,3091,"uc"],
[14275,0.29,2024,-0.725,51.529,5152,"o"],
[14356,1.3,,-3.437,51.525,26600,"uc"],
[14415,2.93,,-2.839,51.392,54622,"uc"],
[14438,0.53,,-1.691,54.975,9649,"uc"],
[14707,0.3,2023,-1.526,53.783,5339,"o"],
[14748,0.17,,-3.238,50.981,2653,"uc"],
[14754,1.7,2024,-0.777,51.283,31573,"o"],
[14774,3.0,2023,-0.27,51.658,59000,"o"],
[14798,1.78,,-2.477,51.216,33072,"uc"],
[14810,0.41,2023,-2.935,53.033,7401,"o"],
[14930,9.89,,0.378,51.863,185043,"uc"],
[14982,0.36,2023,-1.205,52.891,6464,"o"],
[15002,0.21,2023,-5.082,50.046,3653,"o"],
[15003,4.5,,-1.075,50.839,84042,"uc"],
[15049,0.24,,0.039,51.511,4215,"uc"],
[15091,0.24,2024,-1.486,54.221,4215,"o"],
[15340,1.05,,-2.644,51.436,19393,"uc"],
[15451,12.0,,0.029,51.332,224582,"uc"],
[15481,2.1,,-5.948,55.853,76600,"uc"],
[15581,1.15,,-0.759,51.278,16600,"uc"],
[15591,2.18,,-2.703,52.961,44600,"uc"],
[15617,9.0,,-4.898,51.697,113400,"uc"],
[15732,0.25,2024,-2.464,51.45,4402,"o"],
[15743,3.25,,-1.158,52.669,60618,"uc"],
[15915,0.71,2024,-2.526,51.738,13022,"o"],
[15973,0.24,2025,-4.134,55.78,5584,"o"],
[16008,49.9,2024,0.193,52.757,1183000,"o"],
[16119,3.38,,-2.194,53.481,63054,"uc"],
[16120,0.75,2025,-4.305,55.956,13772,"o"],
[16367,2.0,2025,-1.439,53.585,28700,"o"],
[16393,120.0,,-1.392,54.612,2248356,"uc"],
[16426,0.38,2023,-1.845,54.856,6838,"o"],
[16739,0.21,,-2.357,51.687,3653,"uc"],
[16871,0.25,2024,-2.628,51.44,4402,"o"],
[17406,0.26,,-2.108,52.806,4590,"uc"],
[17782,0.29,2025,-0.393,51.695,5152,"o"],
[18382,10.0,2025,0.577,52.546,184000,"o"],
[19113,0.45,2025,-0.406,51.304,8150,"o"],
[19627,0.37,2025,-0.992,51.138,6651,"o"],
]
